webpackJsonp([0],Array(32).concat([
/* 32 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4bWw6c3BhY2U9InByZXNlcnZlIiBzdHlsZT0iZmlsbC1ydWxlOmV2ZW5vZGQ7Y2xpcC1ydWxlOmV2ZW5vZGQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEuNDE0MjE7Ij48cGF0aCBkPSJNNDY4LjgzMiwxNi42NTRsLTQyNS43OTQsMGMtMTQuNTY4LDAgLTI2LjM4NCwxMS44NDYgLTI2LjM4NCwyNi40MTRsMCw0MjUuNzM0YzAsMTQuNjI4IDExLjgxNiwyNi40NzQgMjYuMzg0LDI2LjQ3NGwyMjkuMjksMGwwLC0xODUuMzc2bC02Mi40NiwwbDAsLTcyLjE1M2w2Mi40NiwwbDAsLTUzLjMwNmMwLC02MS44MzIgMzcuNjkxLC05NS40ODUgOTIuODUyLC05NS40ODVjMjYuNDc0LDAgNDkuMTQ5LDEuOTE1IDU1LjY3LDIuODcybDAsNjQuNTg0bC0zOC4xNywwYy0yOS45NzQsMCAtMzUuODM3LDE0LjIzOSAtMzUuODM3LDM1LjIwOGwwLDQ2LjEyN2w3MS41ODQsMGwtOS4zMzMsNzIuMTUzbC02Mi4yNTEsMGwwLDE4NS4zNzZsMTIxLjk4OSwwYzE0LjU5OCwwIDI2LjQ0NCwtMTEuODQ2IDI2LjQ0NCwtMjYuNDc0bDAsLTQyNS43MzRjMCwtMTQuNTY4IC0xMS44NDYsLTI2LjQxNCAtMjYuNDQ0LC0yNi40MTQiIHN0eWxlPSJmaWxsOiMyMzFmMjA7ZmlsbC1ydWxlOm5vbnplcm87Ii8+PC9zdmc+"

/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 35 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4bWw6c3BhY2U9InByZXNlcnZlIiBzdHlsZT0iZmlsbC1ydWxlOmV2ZW5vZGQ7Y2xpcC1ydWxlOmV2ZW5vZGQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEuNDE0MjE7Ij48cGF0aCBkPSJNNTAzLjQ4NCwxMDMuNDM1Yy0xOC4xNDUsOC4wMiAtMzcuNjk1LDEzLjUwMSAtNTguMTYyLDE1LjkwNGMyMC45LC0xMi41MjkgMzYuOTkzLC0zMi4zNDggNDQuNTI2LC01NS45NzVjLTE5LjU3NiwxMS41MyAtNDEuMjA1LDE5Ljk4MiAtNjQuMjkxLDI0LjU0NWMtMTguNTI0LC0xOS43NjUgLTQ0Ljc5NywtMzEuOTk3IC03My45NTksLTMxLjk5N2MtNTUuOTQ4LDAgLTEwMS4yNTcsNDUuMzYzIC0xMDEuMjU3LDEwMS4yNTdjMCw3Ljk2NiAwLjgzNywxNS42ODggMi41OTIsMjMuMTQxYy04NC4yMTksLTQuMjM5IC0xNTguODI2LC00NC41OCAtMjA4Ljc3OSwtMTA1Ljg3NWMtOC43NDksMTQuOTMyIC0xMy43NzEsMzIuMzc1IC0xMy43NzEsNTAuOTI2YzAsMzUuMTI5IDE3LjkyOSw2Ni4xMjggNDUuMDkzLDg0LjM1NGMtMTYuNjMzLC0wLjU2NyAtMzIuMTU5LC01LjE1NyAtNDUuODQ5LC0xMi42NjRsMCwxLjI2OWMwLDQ5LjA2MyAzNC44ODYsOTAuMDI1IDgxLjIyMSw5OS4yODZjLTguNTMyLDIuMzc3IC0xNy40NywzLjU2NSAtMjYuNjc3LDMuNTY1Yy02LjU4OSwwIC0xMi45MDcsLTAuNjIxIC0xOS4wMzcsLTEuODA5YzEyLjg4LDQwLjIwNiA1MC4yNTEsNjkuNTMgOTQuNjE1LDcwLjM2N2MtMzQuNzI0LDI3LjE2NCAtNzguMzYsNDMuMzkyIC0xMjUuODU2LDQzLjM5MmMtOC4xMjgsMCAtMTYuMjI4LC0wLjU2NyAtMjQuMTY3LC0xLjQ1OGM0NC44NSwyOC43MyA5OC4xMjUsNDUuNDk4IDE1NS4zMTUsNDUuNDk4YzE4Ni4yODcsMCAyODguMjQ3LC0xNTQuMzQzIDI4OC4yNDcsLTI4OC4yMTljMCwtNC4zNzQgLTAuMTM1LC04LjcyMiAtMC4zMjQsLTEzLjEyM2MxOS43NjUsLTE0LjMxMSAzNi45NjUsLTMyLjEzMiA1MC41MiwtNTIuMzg0IiBzdHlsZT0iZmlsbDojMjMxZjIwO2ZpbGwtcnVsZTpub256ZXJvOyIvPjwvc3ZnPg=="

/***/ }),
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(197)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(117),
  /* template */
  __webpack_require__(366),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(196)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(123),
  /* template */
  __webpack_require__(365),
  /* scopeId */
  "data-v-d7d7fd7a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(191)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(130),
  /* template */
  __webpack_require__(360),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./1.jpg": 199,
	"./10.jpg": 200,
	"./1019.jpg": 201,
	"./1020.jpg": 202,
	"./1021.jpg": 203,
	"./1022.jpg": 204,
	"./1023.jpg": 205,
	"./1024.jpg": 206,
	"./1025.jpg": 207,
	"./1026.jpg": 208,
	"./1027.jpg": 209,
	"./1028.jpg": 210,
	"./1029.jpg": 211,
	"./1030.jpg": 212,
	"./1031.jpg": 213,
	"./1032.jpg": 214,
	"./1033.jpg": 215,
	"./1034.jpg": 216,
	"./1035.jpg": 217,
	"./1036.jpg": 218,
	"./1037.jpg": 219,
	"./1038.jpg": 220,
	"./1039.jpg": 221,
	"./1040.jpg": 222,
	"./1041.jpg": 223,
	"./1042.jpg": 224,
	"./1043.jpg": 225,
	"./1044.jpg": 226,
	"./1045.jpg": 227,
	"./1046.jpg": 228,
	"./1047.jpg": 229,
	"./1048.jpg": 230,
	"./1049.jpg": 231,
	"./1050.jpg": 232,
	"./1051.jpg": 233,
	"./1052.jpg": 234,
	"./1053.jpg": 235,
	"./1054.jpg": 236,
	"./1055.jpg": 237,
	"./1056.jpg": 238,
	"./1057.jpg": 239,
	"./1058.jpg": 240,
	"./1059.jpg": 241,
	"./1060.jpg": 242,
	"./1061.jpg": 243,
	"./1062.jpg": 244,
	"./1063.jpg": 245,
	"./1064.jpg": 246,
	"./1065.jpg": 247,
	"./1066.jpg": 248,
	"./1067.jpg": 249,
	"./1068.jpg": 250,
	"./1069.jpg": 251,
	"./1070.jpg": 252,
	"./1071.jpg": 253,
	"./1072.jpg": 254,
	"./1073.jpg": 255,
	"./1074.jpg": 256,
	"./1075.jpg": 257,
	"./1076.jpg": 258,
	"./1077.jpg": 259,
	"./1078.jpg": 260,
	"./1079.jpg": 261,
	"./1080.jpg": 262,
	"./1081.jpg": 263,
	"./1082.jpg": 264,
	"./1083.jpg": 265,
	"./1084.jpg": 266,
	"./1085.jpg": 267,
	"./1086.jpg": 268,
	"./1087.jpg": 269,
	"./1088.jpg": 270,
	"./1089.jpg": 271,
	"./1090.jpg": 272,
	"./1091.jpg": 273,
	"./1092.jpg": 274,
	"./1093.jpg": 275,
	"./1094.jpg": 276,
	"./1095.jpg": 277,
	"./1096.jpg": 278,
	"./1097.jpg": 279,
	"./1098.jpg": 280,
	"./1099.jpg": 281,
	"./11.jpg": 282,
	"./12.jpg": 283,
	"./13.jpg": 284,
	"./14.jpg": 285,
	"./15.jpg": 286,
	"./16.jpg": 287,
	"./17.jpg": 288,
	"./18.jpg": 289,
	"./2.jpg": 290,
	"./2000.jpg": 291,
	"./2001.jpg": 292,
	"./2002.jpg": 293,
	"./2003.jpg": 294,
	"./2004.png": 295,
	"./2005.jpg": 296,
	"./2006.jpg": 297,
	"./2007.jpg": 298,
	"./2008.jpg": 299,
	"./2009.jpg": 300,
	"./2010.jpg": 301,
	"./2011.jpg": 302,
	"./2012.jpg": 303,
	"./2013.jpg": 304,
	"./2014.jpg": 305,
	"./2015.jpg": 306,
	"./2016.jpg": 307,
	"./2018.jpg": 308,
	"./2019.jpg": 309,
	"./2020.jpg": 310,
	"./2021.jpg": 311,
	"./2022.jpg": 312,
	"./2023.jpg": 313,
	"./2024.jpg": 314,
	"./2025.jpg": 315,
	"./2026.jpg": 316,
	"./2027.jpg": 317,
	"./2028.jpg": 318,
	"./2029.jpg": 319,
	"./2030.jpg": 320,
	"./2031.jpg": 321,
	"./2032.jpg": 322,
	"./3.jpg": 323,
	"./4.jpg": 324,
	"./5.jpg": 325,
	"./6.jpg": 326,
	"./7.jpg": 327,
	"./8.jpg": 328,
	"./9.jpg": 329,
	"./_1021.jpg": 330,
	"./facebook.svg": 32,
	"./facebook_grey.svg": 33,
	"./font/Recta.eot": 332,
	"./font/Recta.otf": 333,
	"./font/Recta.ttf": 334,
	"./font/Recta.woff": 335,
	"./font/Recta.woff2": 336,
	"./instagram.svg": 34,
	"./logo.png": 331,
	"./twitter.svg": 35
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63;

/***/ }),
/* 64 */,
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{ id: '124', titolo: 'Enlargement of the Palazzo dei Diamanti Modern Art Gallery, Ferrara', tipologia: '1,2', tema: '2,4,5', stato: 'concorso', link: '1', home: '1', peso: 70 }, { id: '87', titolo: 'Via Monviso Square and Gardens, Garbagnate', tipologia: '1', tema: '4', stato: 'ongoing', link: '1', home: '', peso: 67 }, { id: '126', titolo: 'Regas R&D Center, Treviglio', tipologia: '1,3', tema: '4,6', stato: 'ongoing', link: '1', home: '1', peso: 68 }, { id: '125', titolo: 'Urban Center, Milano', tipologia: '2', tema: '1,2,4', stato: 'ongoing', link: '1', home: '', peso: 30 }, { id: '123', titolo: 'TECA, Music Centre, Cassano d\'Adda', tipologia: '1,2', tema: '4', stato: 'ongoing', link: '1', home: '', peso: 72 }, { id: '108', titolo: 'Social Housing, Genoa', tipologia: '4', tema: '3,7', stato: 'progetto', link: '1', home: '', peso: 64 }, { id: '115', titolo: 'PStudents residence Palestro 3 , Turin', tipologia: '4', tema: '1,3,4', stato: 'progetto', link: '1', home: '1', peso: 65 }, { id: '116', titolo: 'GFT Italy Headquarter,  Milan', tipologia: '3', tema: '1,4,5', stato: 'realizzato', link: '1', home: '1', peso: 51 }, { id: '122', titolo: 'Multipurpose Building, Agroscope Posieux', tipologia: '1,2', tema: '4,6', stato: 'concorso', link: '1', home: '', peso: 25 }, { id: '92', titolo: 'Multi-family residential, Milan', tipologia: '4', tema: '6,7', stato: 'completed', link: '1', home: '1', peso: 62 }, { id: '107', titolo: 'Social Housing, La Spezia          ', tipologia: '4', tema: '', stato: 'ongoing', link: '1', home: '1', peso: 76 }, { id: '101', titolo: 'Municipal building, Denklingen', tipologia: '1,2', tema: '4', stato: 'competition', link: '1', home: '1', peso: 39 }, { id: '14', titolo: 'Public Library, Lonate Ceppino ', tipologia: '2', tema: '2,3,4,5,6', stato: 'completed', link: '1', home: '1', peso: 53 }, { id: '111', titolo: 'Media Library, Montbonnot-Saint-Martin ', tipologia: '1,2', tema: '2,4,6', stato: 'competition', link: '1', home: '1', peso: 32 }, { id: '88', titolo: 'Serlachius Museum G\xF6sta extension, Helsinki', tipologia: '1,2', tema: '2,4,6', stato: 'competition', link: '1', home: '', peso: 0 }, { id: '90', titolo: 'Sempla headquarter, Turin', tipologia: '3', tema: '1,2,3', stato: 'completed', link: '1', home: '1', peso: 59 }, { id: '22', titolo: 'Bridge on Serio river and cyclable path, Nembro', tipologia: '1', tema: '4', stato: 'completed', link: '1', home: '', peso: 30 }, { id: '120', titolo: 'Piazza Carrara, Bergamo', tipologia: '1', tema: '4', stato: 'competition', link: '1', home: '1', peso: 35 }, { id: '114', titolo: 'Temporary residences, Torino', tipologia: '4', tema: '1,3,4', stato: 'competition', link: '1', home: '', peso: 43 }, { id: '29', titolo: 'Transformation of a military area, Karlsruhe', tipologia: '1', tema: '7', stato: 'competition', link: '', home: '', peso: 10 }, { id: '106', titolo: 'Daria Town Residence Masterplan, Ulaanbataar', tipologia: '1,4', tema: '', stato: 'ongoing', link: '1', home: '1', peso: 30 }, { id: '86', titolo: 'Swiss & Global Offices, Milano', tipologia: '3', tema: '1,2,5', stato: 'completed', link: '1', home: '', peso: 66 }, { id: '13', titolo: 'Civic Centre with public library, Ranica', tipologia: '2', tema: '4,5,6', stato: 'completed', link: '1', home: '1', peso: 61 }, { id: '113', titolo: 'Temporary residences, Milano', tipologia: '4', tema: '1,3', stato: 'completed', link: '1', home: '', peso: 26 }, { id: '94', titolo: 'New squares Ex-Enel area, Milan', tipologia: '1', tema: '2,4', stato: 'competition', link: '1', home: '1', peso: 41 }, { id: '119', titolo: 'Telecom Headquarter', tipologia: '3', tema: '1,4,5', stato: 'competition', link: '1', home: '', peso: 28 }, { id: '16', titolo: 'Civic Library, Stockholm', tipologia: '2', tema: '2,4', stato: 'competition', link: '1', home: '1', peso: 37 }, { id: '109', titolo: 'Temporary residences, Milano', tipologia: '4', tema: '1', stato: 'completed', link: '1', home: '', peso: 28 }, { id: '97', titolo: 'Square, parking and green area, Cassano d\'Adda', tipologia: '1', tema: '4', stato: 'ongoing', link: '', home: '', peso: 45 }, { id: '93', titolo: 'TBC Bank Headquarter, Tbilisi Georgia', tipologia: '3', tema: '2,5,6', stato: 'competition', link: '1', home: '1', peso: 33 }, { id: '67', titolo: 'Single - family house, Canelli ', tipologia: '4', tema: '1,2,6,7', stato: 'completed', link: '1', home: '', peso: 28 }, { id: '24', titolo: 'Civic Centre with public library, Castellanza ', tipologia: '2', tema: '2,3,4,6', stato: 'completed', link: '1', home: '1', peso: 49 }, { id: '7', titolo: 'Master plan velodrome area , Dalmine ', tipologia: '1,4', tema: '', stato: 'competition', link: '', home: '', peso: 3 }, { id: '105', titolo: 'Residential building for 60 small apartments, Milano', tipologia: '4', tema: '4,5,6', stato: 'competition', link: '1', home: '1', peso: 40 }, { id: '102', titolo: 'Conference and Residential Centre, Benediktbeuren', tipologia: '1,2,4', tema: '4', stato: 'competition', link: '1', home: '', peso: 30 }, { id: '31', titolo: 'Moltisolitudine, Deep Inside exhibit, Florence', tipologia: '5', tema: '1', stato: 'completed', link: '1', home: '', peso: 30 }, { id: '110', titolo: 'Urban renovation and senior center, Dettingen', tipologia: '1,4', tema: '4,6', stato: 'competition', link: '1', home: '', peso: 27 }, { id: '51', titolo: 'Artopia art gallery, Milano', tipologia: '2', tema: '1', stato: 'completed', link: '', home: '', peso: 15 }, { id: '5', titolo: '3dC office building, Milano', tipologia: '3', tema: '4,5,6', stato: 'project', link: '1', home: '1', peso: 38 }, { id: '70', titolo: 'Requalification external areas Terrazzano cemetery', tipologia: '1', tema: '4', stato: 'completed', link: '', home: '', peso: 19 }, { id: '68', titolo: 'Interior design', tipologia: '', tema: '1', stato: 'completed', link: '0', home: '', peso: 25 }, { id: '121', titolo: 'Piazza Risorgimento, Bergamo', tipologia: '1', tema: '4', stato: 'competition', link: '1', home: '', peso: 30 }, { id: '112', titolo: 'Residential building ongoing Garibaldi, Torino', tipologia: '4', tema: '3,4', stato: 'competition', link: '1', home: '1', peso: 34 }, { id: '85', titolo: 'Residential complex, Tavazzano', tipologia: '1,4', tema: '3,7', stato: 'project', link: '', home: '', peso: 25 }, { id: '71', titolo: 'Single - family house, Capriate', tipologia: '4', tema: '1,6', stato: 'completed', link: '1', home: '', peso: 27 }, { id: '69', titolo: 'Security Centre and Auditorium, Cassano d\u2019Adda', tipologia: '1,2', tema: '4,5', stato: 'project', link: '1', home: '', peso: 18 }, { id: '4', titolo: 'Requalification of River Olona valley, Castellanza', tipologia: '1', tema: '4', stato: 'competition', link: '', home: '', peso: 2 }, { id: '118', titolo: 'Piazza della Repubblica, Varese', tipologia: '1', tema: '4', stato: 'competition', link: '', home: '', peso: 30 }, { id: '100', titolo: 'Kindergarden, Kiritz', tipologia: '2', tema: '2', stato: 'competition', link: '', home: '', peso: 29 }, { id: '99', titolo: 'Transformation industrial building, new office building, Milano', tipologia: '3', tema: '3,7', stato: 'project', link: '', home: '', peso: 28 }, { id: '98', titolo: 'Transformation Villa Morando, residential building, Albisola', tipologia: '4', tema: '7', stato: 'project', link: '', home: '', peso: 27 }, { id: '95', titolo: 'New civic centre, feasibility study, Treviglio', tipologia: '2', tema: '2,4', stato: 'project', link: '', home: '', peso: 26 }, { id: '91', titolo: 'Public Library, Monza', tipologia: '2', tema: '2,3', stato: 'competition', link: '1', home: '1', peso: 31 }, { id: '83', titolo: 'Restoration and enlargement of a historical building, Montmorency', tipologia: '4', tema: '3', stato: 'completed', link: '', home: '', peso: 24 }, { id: '81', titolo: 'Law Court restoration, Lugano', tipologia: '2,3', tema: '2,3,6', stato: 'competition', link: '', home: '', peso: 23 }, { id: '80', titolo: 'Premises for the CSAI offices, Terranuova Bracciolini', tipologia: '1,2,3', tema: '6', stato: 'competition', link: '', home: '', peso: 22 }, { id: '79', titolo: 'Chamber of Commerce of Monza and Brianza Offices', tipologia: '2,3', tema: '2,6', stato: 'competition', link: '', home: '', peso: 21 }, { id: '73', titolo: 'Office and commercial building, Pesaro', tipologia: '3', tema: '6', stato: 'competition', link: '1', home: '', peso: 25 }, { id: '57', titolo: 'Multipurpose building, Canelli', tipologia: '2', tema: '4', stato: 'completed', link: '', home: '', peso: 16 }, { id: '50', titolo: 'Cultural relaunching "Naviglio Grande" area, Milano', tipologia: '5', tema: '4', stato: 'project', link: '', home: '', peso: 14 }, { id: '37', titolo: 'Zeffirelli exhibit setting up, Milano', tipologia: '5', tema: '1', stato: 'completed', link: '', home: '', peso: 13 }, { id: '36', titolo: 'Offices and retail building, Seregno', tipologia: '3', tema: '1', stato: 'completed', link: '', home: '', peso: 12 }, { id: '33', titolo: 'CANT Art and Technologiy Centre, Vimodrone', tipologia: '5', tema: '4', stato: 'project', link: '', home: '', peso: 11 }, { id: '30', titolo: 'Residential and commercial building, Milano', tipologia: '3,4', tema: '5,7', stato: 'completed', link: '1', home: '', peso: 30 }, { id: '27', titolo: 'Masterplan and residential district, Drancy', tipologia: '4', tema: '2,3,4', stato: 'competition', link: '1', home: '', peso: 27 }, { id: '26', titolo: 'Tangram \u2013 ville. Play with the town!, educational program', tipologia: '5', tema: '', stato: 'completed', link: '1', home: '', peso: 30 }, { id: '25', titolo: 'Urban Centre, Florence', tipologia: '2', tema: '3,4', stato: 'competition', link: '1', home: '', peso: 28 }, { id: '21', titolo: 'Residential building, Milano', tipologia: '4', tema: '6,7', stato: 'completed', link: '', home: '', peso: 9 }, { id: '17', titolo: 'Shopping centre Trony, Dalmine', tipologia: '3', tema: '4', stato: 'project', link: '', home: '', peso: 8 }, { id: '15', titolo: 'Public Library into the \u201CSpedale di S. Antonio\u201D, Lastra Signa', tipologia: '2', tema: '2,3,4', stato: 'project', link: '', home: '', peso: 7 }, { id: '11', titolo: 'Art and technologies Centre , Pero', tipologia: '5', tema: '4', stato: 'project', link: '', home: '', peso: 6 }, { id: '10', titolo: 'Farm renovation and transformation in residential estate, Dalmine ', tipologia: '4', tema: '3,6', stato: 'project', link: '', home: '', peso: 5 }, { id: '6', titolo: 'Multipurpose building G99, Milano', tipologia: '3', tema: '2,4,6,7', stato: 'project', link: '1', home: '', peso: 30 }, { id: '1', titolo: 'Public Library, Legnano', tipologia: '2', tema: '4', stato: 'competition', link: '', home: '', peso: 1 }, { id: '78', titolo: 'A101 Urban Block, Design of urban residential blocks, Moscow', tipologia: '1,4', tema: '4', stato: 'competition', link: '1', home: '', peso: 28 }, { id: '64', titolo: 'Residential unit, Tavazzano ', tipologia: '4', tema: '1,3', stato: 'project', link: '', home: '', peso: 17 }, { id: '3', titolo: 'Masterplan and Landsbanki Islands headquarters, Reykjavik', tipologia: '1,3', tema: '4,5', stato: 'competition', link: '1', home: '1', peso: 33 }, { id: '35', titolo: 'Adidas Factory Outlet, Herzogenaurach', tipologia: '1,3', tema: '4', stato: 'competition', link: '1', home: '', peso: 28 }, { id: '23', titolo: 'Public Library, Bolzano', tipologia: '1,2', tema: '4,6', stato: 'competition', link: '1', home: '', peso: 29 }, { id: '18', titolo: 'Ferretti International headquarters, Dalmine', tipologia: '3', tema: '5,6,7', stato: 'completed', link: '1', home: '1', peso: 45 }, { id: '9', titolo: 'Child care, kindergarten and urban park, Roma', tipologia: '1,2', tema: '4', stato: 'competition', link: '', home: '', peso: 4 }, { id: '2', titolo: 'Requalification of three squares, Dalmine ', tipologia: '1', tema: '4', stato: 'competition', link: '1', home: '', peso: 5 }, { id: '41', titolo: 'L\'Ape Piera restaurant and wine bar, Milano', tipologia: '3', tema: '1', stato: 'completed', link: '1', home: '', peso: 28 }, { id: '127', titolo: 'Marco Martello School, Petriolo', tipologia: '1,2', tema: '4,6', stato: 'ongoing', link: '1', home: '', peso: 47 }, { id: '128', titolo: 'GFT Headquarter, Torino', tipologia: '3', tema: '1,5', stato: 'ongoing', link: '1', home: '1', peso: 57 }, { id: '129', titolo: 'Villa in Sicily', tipologia: '4', tema: '1,7', stato: 'ongoing', link: '1', home: '1', peso: 78 }, { id: '130', titolo: 'Requalification of the historical centre', tipologia: '1,2,4', tema: '3,4,7', stato: 'ongoing', link: '1', home: '', peso: 74 }, { id: '131', titolo: 'Masterplan Scalo Farini', tipologia: '1', tema: '4,6,7', stato: 'ongoing', link: '1', home: '', peso: 55 }, { id: '132', titolo: 'Masterplan Scalo San Cristoforo', tipologia: '1', tema: '4,6,7', stato: 'ongoing', link: '1', home: '', peso: 30 }, { id: '133', titolo: 'Fitting room n 16, Arcimboldi Theater, Milano', tipologia: '2', tema: '1,5', stato: 'ongoing', link: '1', home: '', peso: 82 }, { id: '134', titolo: 'Cultural Centre, Pero', tipologia: '1,2', tema: '4,6,7', stato: '', link: '1', home: '1', peso: 92 }, { id: '135', titolo: 'Strategic project for the public space, Pero', tipologia: '1', tema: '4,7', stato: '', link: '1', home: '', peso: 93 }, { id: '136', titolo: 'Rede Cultural Centre, Parabiago', tipologia: '1,2', tema: '2,3,7,6', stato: '', link: '1', home: '1', peso: 94 }, { id: '137', titolo: 'Cultural Centre Ex Caserma Garibaldi, Varese', tipologia: '2', tema: '2,3,4', stato: '', link: '1', home: '1', peso: 88 }, { id: '138', titolo: 'Library and Cultural Center, Mezzolombardo', tipologia: '2', tema: '2,3,4', stato: '', link: '1', home: '1', peso: 95 }, { id: '139', titolo: 'UPTOHOME SHORT-STAY APARTMENTS, MILANO', tipologia: '4', tema: '1', stato: '', link: '1', home: '1', peso: 96 }, { id: '140', titolo: 'REHEARSAL ROOM, TEATRO DELL\'OPERA DI ROMA', tipologia: '2', tema: '4,5', stato: '', link: '1', home: '1', peso: 97 }, { id: '141', titolo: 'GRIGOLETTI PRIMARY SCHOOL, PORDENONE', tipologia: '2', tema: '2,4,7', stato: '', link: '1', home: '', peso: 98 }, { id: '142', titolo: 'TRAVAINI PRIMARY SCHOOL, PARABIAGO', tipologia: '1,2', tema: '4,5', stato: '', link: '1', home: '', peso: 99 }, { id: '143', titolo: 'Office building, Endine', tipologia: '3', tema: '4,6', stato: '', link: '1', home: '1', peso: 100 }, { id: '144', titolo: 'Contemporary Art Incubator, Vicenza', tipologia: '2', tema: '2,4,7', stato: '', link: '1', home: '1', peso: 101 }, { id: '145', titolo: 'Reuse Lambrate. Residential building', tipologia: '4', tema: '3,7', stato: '', link: '1', home: '0', peso: 102 }]);

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(367);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

function load(name) {
  return __webpack_require__(369)("./" + name + '.vue');
}
var mode =  true ? 'history' : 'hash';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({

  mode: mode,
  base: '/eng/',

  routes: [{ path: '/', redirect: '/home' }, { path: '/savethedate', name: 'savethedate', components: { main: load('Savethedate') } }, { path: '/home', name: 'home', meta: { nav: true }, components: { main: load('Home') } }, { path: '/progetti', name: 'progetti', meta: { nav: true }, components: { main: load('Progetti') } }, { path: '/tipologia/:id/:tipologia', name: 'tipologia', meta: { nav: true }, components: { main: load('Tipologia') } }, { path: '/tema/:id/:tema', name: 'tema', meta: { nav: true }, components: { main: load('Tema') } }, { path: '/inside/:area/:page', name: 'inside', meta: { nav: true }, components: { main: load('Inside') } }, { path: '*', components: { main: load('Home') } }]
}));

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
   version: '1.0.0',
   urlsite: document.location.origin + '/eng/',
   app: document.URL.indexOf('https://') === -1 && document.URL.indexOf('https://') === -1,
   uuid: '0123456789',
   onesignal: 'non disponibile',
   platform: document.URL.indexOf('https://') === -1 && document.URL.indexOf('https://') === -1 ? 'app' : 'desktop',
   online: true,
   innerHeight: window.innerHeight,
   innerWidth: window.innerWidth,
   screenHeight: screen.height,
   height: window.innerHeight,
   width: screen.width,
   pixelRatio: window.devicePixelRatio,

   mobMmenu: false,

   device: function device() {
      if (this.innerWidth > 769) {
         return "desktop";
      } else if (this.innerWidth < 500) {
         return "mobile";
      } else {
         return "tablet";
      }
   },

   area: function area() {
      return this.height * this.width;
   },

   SortAsc: function SortAsc(objToOrder, prop, type) {
      console.log('Sto ordinando in modo crescente per: ' + prop);
      if (type == 'string') {
         objToOrder.sort(function (a, b) {
            if (typeof a[prop] != 'string' && typeof b[prop] == 'string') return -1;
            if (typeof a[prop] == 'string' && typeof b[prop] != 'string') return 1;
            if (typeof a[prop] == 'string' && typeof b[prop] == 'string') {
               var nameA = a[prop].toString().toLowerCase(),
                   nameB = b[prop].toString().toLowerCase();
               if (nameA < nameB) return -1;
               if (nameA > nameB) return 1;
            }
            return 0;
         });
      }
      if (type == 'int') {
         objToOrder.sort(function (a, b) {
            var numbA = a[prop];
            var numbB = b[prop];
            return numbA - numbB;
         });
      }
      if (type == 'data') {
         objToOrder.sort(function (a, b) {
            return new Date(a[prop]) - new Date(b[prop]);
         });
      }
   },
   SortDesc: function SortDesc(objToOrder, prop, type) {
      console.log('Sto ordinando in modo decrescente per: ' + prop);
      if (type == 'string') {
         objToOrder.sort(function (a, b) {
            if (typeof a[prop] == 'string' && typeof b[prop] == 'string') {
               var nameA = a[prop].toLowerCase(),
                   nameB = b[prop].toLowerCase();
               if (nameA < nameB) return 1;
               if (nameA > nameB) return -1;
            }
            if (typeof a[prop] != 'string' && typeof b[prop] == 'string') return 1;
            if (typeof a[prop] == 'string' && typeof b[prop] != 'string') return -1;
            return 0;
         });
      }
      if (type == 'int') {
         objToOrder.sort(function (a, b) {
            var numbA = a[prop];
            var numbB = b[prop];
            return numbB - numbA;
         });
      }
      if (type == 'data') {
         objToOrder.sort(function (a, b) {
            return new Date(b[prop]) - new Date(a[prop]);
         });
      }
   }
});

/***/ }),
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 72 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 73 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 74 */,
/* 75 */,
/* 76 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(194)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(363),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header_mobile_vue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header_mobile_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Header_mobile_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Site_side_vue__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Site_side_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Site_side_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    headerMobile: __WEBPACK_IMPORTED_MODULE_0__components_Header_mobile_vue___default.a,

    siteSide: __WEBPACK_IMPORTED_MODULE_1__components_Site_side_vue___default.a
  },
  data: function data() {
    return {
      larghezza: 0
    };
  },
  created: function created() {
    console.log("Created App.vue");
    console.log(this.$route.path);
  },

  mounted: function mounted() {
    this.larghezza = parseInt(this.$refs.app.clientWidth);
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize: function handleResize() {
      this.$teras.innerHeight = window.innerHeight;
      this.$teras.innerWidth = window.innerWidth;

      this.larghezza = parseInt(this.$refs.app.clientWidth);
      console.log(this.$teras.width + ' - ' + this.$teras.innerWidth);
      console.log(window.innerWidth);
    }
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
      name: 'site-header-mobile',
      data: function data() {
            return {
                  tipologiePopV: false,
                  temiPopV: false
            };
      }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__News__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__News___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__News__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  components: {
    news: __WEBPACK_IMPORTED_MODULE_0__News___default.a
  },
  data: function data() {
    return {
      title: '',
      page: ''
    };
  },
  created: function created() {
    var parent = this;
    console.log("Arrivo alla Home");
  },

  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},
  methods: {
    handleResize: function handleResize() {
      this.larghezza = parseInt(this.$refs.rmain.clientWidth) / 2;
      console.log(this.larghezza);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'site-header',
  components: {}
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'site-header',
  components: {}
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'inside',
  data: function data() {
    return {
      title: '',
      page: '',
      html: ''
    };
  },
  created: function created() {
    console.log("Arrivo al Inside.vue con page  " + this.$route.params.page);
    this.fetchData();
  },

  watch: {
    '$route': 'fetchData'
  },
  methods: {
    fetchData: function fetchData() {
      this.loading = true;
      var parent = this;
      this.axios.get('page/' + this.$route.params.page + '.html', { responseType: 'document' }).then(function (response) {
        parent.title = response.request.response.body.children.item(0).innerHTML;
        document.title = parent.title;


        var res = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].compile('<div id="page" class="inside-in">' + response.request.response.body.children.item(1).innerHTML + '</div>');
        var vm = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
          router: parent.$router,
          render: res.render,
          staticRenderFns: res.staticRenderFns
        });
        vm.$mount('#page');

        console.log(res);
      }).catch(function (error) {
        console.log(error);
        parent.$route.push('/inside/error/not-find');
      });
    }
  }
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'news',
  props: {
    titolo: '',
    link: '',
    image: ''
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loading: true,
      title: '',
      page: ''
    };
  },
  created: function created() {
    console.log("Arrivo al site-page.vue con page  " + this.$route.params.page);

    this.fetchData();
    this.$teras.pageHeader = 40;
  },

  watch: {
    '$route': 'fetchData'
  },
  methods: {
    fetchData: function fetchData() {
      this.loading = true;
      var parent = this;
      this.axios.get('page/' + this.$route.params.page + '.html', { responseType: 'document' }).then(function (response) {
        parent.title = response.request.response.body.children.item(0).innerHTML;
        parent.page = response.request.response.body.children.item(1).innerHTML;
        parent.loading = false;
      }).catch(function (error) {
        console.log(error);
        parent.$route.push('/inside/error/not-find');
      });
    },
    invitationMenu: function invitationMenu(command) {
      this.$router.push('/page/invitation/' + command);
    },
    infoMenu: function infoMenu(command) {
      if (command == 'metromap') {
        this.$router.push('/map/metro');
      } else {
        this.$router.push('/page/info/' + command);
      }
    }
  }

});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'news',
  props: {
    titolo: '',
    link: '',
    image: ''
  },
  computed: {
    filtrati: function filtrati() {
      var itemsFilter = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.$teras.progetti), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (item.home == '1') itemsFilter.push(item);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return itemsFilter;
    }
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'savethedate'
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'site-footer',
  components: {}
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'site-header',
  components: {}
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'site-navbar',
  created: function created() {
    console.log("Created Site-logged.vue");
  },

  methods: {
    handleSelect: function handleSelect(key, keyPath) {
      if (keyPath == '/sezione/2/') {} else if (keyPath == '/page/f/4') {} else {}

      console.log();
    }
  }
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'site-side',
  data: function data() {
    return {
      tipologiePopV: false,
      temiPopV: false
    };
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'news',
  props: {
    titolo: '',
    link: '',
    image: ''
  },
  computed: {
    filtrati: function filtrati() {
      var itemsFilter = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.$teras.progetti), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (item.tema.toLowerCase().indexOf(this.$route.params.id.toLowerCase()) > -1) itemsFilter.push(item);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return itemsFilter;
    }
  }
});

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'news',
  props: {
    titolo: '',
    link: '',
    image: ''
  },
  computed: {
    filtrati: function filtrati() {
      var itemsFilter = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.$teras.progetti), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (item.tipologia.toLowerCase().indexOf(this.$route.params.id.toLowerCase()) > -1) itemsFilter.push(item);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return itemsFilter;
    }
  }
});

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__teras__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_index_css__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_it__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_axios__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__css_grid_css__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__css_grid_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__css_grid_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__css_layout_css__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__css_layout_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__css_layout_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__progetti__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_analytics__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_analytics__);



__webpack_require__(70).polyfill();





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui___default.a, { locale: __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_it___default.a });



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_7_axios___default.a);
if (true) __WEBPACK_IMPORTED_MODULE_7_axios___default.a.defaults.baseURL = __WEBPACK_IMPORTED_MODULE_3__teras__["a" /* default */].urlsite;

__WEBPACK_IMPORTED_MODULE_7_axios___default.a.defaults.validateStatus = function (status) {
  return status >= 200 && status < 300 && status != 210;
};





__WEBPACK_IMPORTED_MODULE_3__teras__["a" /* default */].progetti = __WEBPACK_IMPORTED_MODULE_11__progetti__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_3__teras__["a" /* default */].SortDesc(__WEBPACK_IMPORTED_MODULE_3__teras__["a" /* default */].progetti, 'peso', 'int');



var googleAnalyticsId = 'UA-2826949-15';
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_analytics___default.a, { id: googleAnalyticsId, router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */], debug: true });

__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].beforeEach(function (to, from, next) {
  console.log(to);
  __WEBPACK_IMPORTED_MODULE_3__teras__["a" /* default */].mobMmenu = false;

  next();
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$teras = __WEBPACK_IMPORTED_MODULE_3__teras__["a" /* default */];
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  data: {
    teras: __WEBPACK_IMPORTED_MODULE_3__teras__["a" /* default */]
  },
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 187 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 198 */,
/* 199 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/10.1fa9e2e.jpg";

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1019.bfee215.jpg";

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1020.b2ef2df.jpg";

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1021.44e728b.jpg";

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1022.241d2dd.jpg";

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1023.cdbba19.jpg";

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1024.a857acc.jpg";

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1025.2263e05.jpg";

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1026.8bf5713.jpg";

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1027.6e3bace.jpg";

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1028.f117b88.jpg";

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1029.fc950d1.jpg";

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1030.8c25ef5.jpg";

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1031.8e1a467.jpg";

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1032.06dc885.jpg";

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1033.5a431df.jpg";

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1034.ffdfaa8.jpg";

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1035.e73685e.jpg";

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1036.8b9b4a1.jpg";

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1037.b44ad4d.jpg";

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1038.dede764.jpg";

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1039.de6728b.jpg";

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1040.e85e8c7.jpg";

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1041.c2b2d2e.jpg";

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1042.b696d19.jpg";

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1043.9a9e92d.jpg";

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1044.da41d4b.jpg";

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1045.4a716aa.jpg";

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1046.68f586b.jpg";

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1047.64326f3.jpg";

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1048.f0abd94.jpg";

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1049.41d28d0.jpg";

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1050.019e1ee.jpg";

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1051.43a4fe1.jpg";

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1052.41cc99b.jpg";

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1053.cad2374.jpg";

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1054.5baeaa9.jpg";

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1055.108aa10.jpg";

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1056.838f55b.jpg";

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1057.c1f1c22.jpg";

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1058.54725e6.jpg";

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1059.d28eac5.jpg";

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1060.88e0b8a.jpg";

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1061.a3df3ab.jpg";

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1062.84b102b.jpg";

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1063.4339305.jpg";

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1064.effe02c.jpg";

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1065.3fa7a7f.jpg";

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1066.f909225.jpg";

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1067.9d9bdbb.jpg";

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1068.474d959.jpg";

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1069.fbd8d78.jpg";

/***/ }),
/* 252 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1071.1c2bf93.jpg";

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1072.0ba4356.jpg";

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1073.8bf4f4f.jpg";

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1074.f3ee330.jpg";

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1075.14a9b13.jpg";

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1076.0a77309.jpg";

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1077.e5dc9a9.jpg";

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1078.b866b75.jpg";

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1079.f6c79c6.jpg";

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1080.98be440.jpg";

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1081.751a1cc.jpg";

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1082.7997733.jpg";

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1083.1c03380.jpg";

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1084.22bbbee.jpg";

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1085.f382d98.jpg";

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1086.262680a.jpg";

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1087.6b7d421.jpg";

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1088.2d2f0f5.jpg";

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1089.b5f8ece.jpg";

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1090.7237626.jpg";

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1091.de88f20.jpg";

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1092.351a71c.jpg";

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1093.e963429.jpg";

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1094.dcd31f6.jpg";

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1095.e5007ea.jpg";

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1096.3d0602a.jpg";

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1097.bb8c9eb.jpg";

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1098.9270517.jpg";

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1099.f270cd3.jpg";

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/11.405ed58.jpg";

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/12.d2d22e5.jpg";

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/13.f9dd8d7.jpg";

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/14.a3fac8d.jpg";

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/15.d93bd04.jpg";

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/16.91ddece.jpg";

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/17.161dfc7.jpg";

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/18.51cb919.jpg";

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2.abef40a.jpg";

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2000.1170bb6.jpg";

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2001.596d3f2.jpg";

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2002.398b00a.jpg";

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2003.3b3ed78.jpg";

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2004.ae021c9.png";

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2005.faf9c42.jpg";

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2006.32493fc.jpg";

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2007.bee2e8d.jpg";

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2008.5f84000.jpg";

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2009.69ebabc.jpg";

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2010.09939cc.jpg";

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2011.ce4933f.jpg";

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2012.fa48711.jpg";

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2013.7446673.jpg";

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2014.4c09952.jpg";

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2015.f888233.jpg";

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2016.82670d3.jpg";

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2018.1c5c6db.jpg";

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2019.4d68523.jpg";

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2020.a614276.jpg";

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2021.227ce19.jpg";

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2022.0de1cb4.jpg";

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2023.11d330c.jpg";

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2024.5b2ab0e.jpg";

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2025.318f985.jpg";

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2026.8da1793.jpg";

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2027.c2440c0.jpg";

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2028.c651da2.jpg";

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2029.6673334.jpg";

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2030.a170d73.jpg";

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2031.9d591ba.jpg";

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2032.82c320c.jpg";

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3.5040ba4.jpg";

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4.8ca9a87.jpg";

/***/ }),
/* 325 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQIAJgAmAAD/2wBDAAMCAgICAgMCAgIDAwMDBAYEBAQEBAgGBgUGCQgKCgkICQkKDA8MCgsOCwkJDRENDg8QEBEQCgwSExIQEw8QEBD/wAALCAFlAUABAREA/8QAHgABAAEEAwEBAAAAAAAAAAAAAAkBBgcIAgQFCgP/xABDEAABAwMDAgQEAgUJBwUAAAABAAIDBAUGBwgREiEJEzFBFCJRYTKBFSNCcZEWJDNTYnKCoaIXJmNzg5KzUpOUscH/2gAIAQEAAD8AlTRERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERFxLw0EnngepVl5jrfo3p4x7871VxKwdA6iy43mngeR9mOeHH8gsMZH4leyrG3OZPrbRV8jDwW2631dV/BzIi0/kVZ1R4uGzOBxbHk2SVAH7UVhmAP8A3cKlN4uGzOd4bJk2SQA/tSWGYj/TyVd+OeJfspyQtZDrXSUD3dg2426rpv4ufF0j+KzNhuuuiuojWOwTVnEb+5/pHb7zTzSfmxr+ofmFe7ZGuAcD2PofquaIiIiIiIiIiIiIiIiIiLiXNHYlYP123pbc9urpaLUbUOkbeYmh36Et387uB59OYmf0fPsZC0fdR9axeNTnV1mqLdodprbrFR92w3K/P+Lq3D2eIYyIoz9i6QLTDVDd/uW1jkldn+s2SVsEpPNFTVPwVGAfbyKcMj/i1YfkllmkMs0jpHu7lzjyT+ZXHk/VOSicn6rlHJJE8SRPcx7TyHNPBB+xWXNMd2+5HR6WKTT/AFlya3wxEEUc1WaujIHsaefrj/0rcvR/xptRrRPT2/W3Ti2ZFRjhk1wsjzRVgHu/ynkxSH7Axj7hSDaEb3dt+4h8Fv0+1CpWXuccix3UfB3An3DY3niUj/hues8BwJ457qqIiIiIiIiIiIiIiIqEgdyVifcDug0c2z42ch1TyyGjllY59DaqcCW4V5B46YYeQT37dbi1g93BRHbnfFU1y1ofUY9pnNJp1iruWdFBPzc6tp7frqkcFg4/Zi6fflzlpLUVVTWTyVVXPJNNM8ySSSOLnvcTyXOJ7kkn1K/NERERERfpDUTU8rJoJHRyROD2PaSHNcO4II7gj6rdDbH4pWu+h76awZ9VyaiYmzpZ8Nc6g/pClYPeGqPLj2/Yl6x9C31Uum3jdZoxudx0XzS/KI5quGMSV1mq+IrjQ9wD5sPJ+XkgdbS5h57OWXwQRyFVEREREREREREREVCeO60J3weJ3i+hrrhplos6iyTPYw6CsrT+st9kf6EO47Tzj+rB6Wn8ZJBYYcc+1DzXVDKq/NtQMlr77fLk/rqK2slL5HfRo9mtA7BrQGgdgAFbiIiIiIiIiL3sJznLtOsloMwwbIrhYr3bZBLS11DMYpYz9OR6tI7Fp5BBIIIPCmD2O+KFj+sctu0s13lo7DnEpFPQ3ZvENvvD/wBlrvaCod6dP4Hu/CWkhikGa4OHIVURERERERERERFRxAHJKiw8RXxKX0k100E2730CVoko8hymjkPLD6PpKN4/a9Q+YendrO/LlFVLK6Vxe4kuceSSeST9VwREREREREREVWuLXBwPcHn1UpHh2eJbLSSWzQbcXfuqlcI6LHsoq5O8Ho1lLWvJ7s9AyY9x2DyR8zZXWnkccd/dckREREREREREVCekclRreKFv0nwOnrNuWjd6khyGriDMmvFJL0vtsLxz8HE4d2zPaeXuHBYxwA+Z3yRBOcXHnlURERERERERERFVri309+ylq8LrftPkgt+2rWW+B9zhjEGJ3irlPXVsHpQSud6yAc+U4/iA6PxBvMngPKqiIiIiIiIiItXt/wBu4pNqukElXZpops2yYS0GO05IPkvDf1lY9p9WRBzSBx8zywehJEAd1utxvVzq7vdq6esrq6Z9TU1M8hfJNK9xc973Hu5znEkk+pK6iIiIiIiIiIiIiLsUFfWW2tguFBVy01VSyNmgmieWvikaQWua4dwQQCCPcKfHw8t30W6TSVtLk1XA3PcUbHR32EOAdVs44irmt9hJwQ7jsJA70BaFtcqoiIiIiIiIvOv9+tGMWWuyO/3GCgtlrppaytqpndMcEEbS573H2AaCfyXzp7vtx153Pa33zUesmnbaGvNDYKOXt8JbY3Hym8egc7l0j/7T3d+OFhT1REREREREREREREWXtqm4O/bZtbLBqjaWS1FJSyfC3eiY7j423yECaL6dXADm89g9jSvozxPJrLmWNWvLMcr4621Xmkhr6GojPyywSsDmO/gQvXRERERERERR4eMFuOfgWlNt0Hx6r6LtnhNRdHMd80NqhePkP082UBv92OQe6hmJ5JKIiIiIiIiIiIiIiKrXdPHHsphvBw3EzZdp7edvuR3ES1+HH9JWQSPJkdbZn/rYxz6iKZwP2E4HoApIFVEREREREXF72saXOIAHck+wXzob3tbanX3crmWcNrTPaoK11psrQeWMt9MTHGW/TrIdKfvIVghEREREREREREREREWZtnus8ugW4nDNSH1jqe3UtwbR3fgnpdb5/wBVP1fUNa4vH3YD7BfR/FLHMwSRPa9jgHNc08hzSOxBXNEREREREWDN7Wrcmim17P8AOaKfyrk21ut1tcOeW1dURBG8fdpk6/8AAvnLdzz3PKoiIiIiIiIiIiIiIiKoPbj6r6ItgeqEmrW03T/I6yr+Ir6G3CyVzy7lxnoyYOp39pzGMcf73PuthURERERERRxeNbnptGjuDadwTBsmR32W4TNB7mGkh44P2L6hh/wqHQn2REREREREREREREREQeqlz8EvUOauwTUbS+omcW2e50l6pGE8gNqY3RSgfYOp4z+96k0VUREREREUMfjUZTLcdwOIYm15MNkxVs/Tz2EtRUyl37vlij/go80REREREREREREREREW/wD4MGSutu5XIcddMWx3rFJ3BvPZ0kNRC4f6XP8A81NQFVERERERUPooIvFqub6/eZfaZ7+RQWa10zR9P1Af/wDbytNUREREREREREREREREW3vhRXQ27ezh9P19LbhQXald39f5lLIB/GMKetERERERFRQI+Ks0jevmXPvSWwj/AOHEtRkREREREREREREREREW0vhhxvk3wab9APyvuTjx9BbqnlfQGiIiIiIiofRQWeLtaXW7eLcaxw4FzsNsqh+THRn/ADjWlaIiIiIiIiIiIiIiIiLcfwlrS65b08cq2t5ba7Tdat3b0BpnRc/xlCnhRERERERUUPXjZ4fJQ6u6f522EiK847NbXP47GSlqC/1+vTUt/go3UREREREREREREREREUiPgqYu+u13zTLnRAxWfGBSdZ/ZfU1MfH8RC5TLoiIiIiIi0A8ZjAHZHtxsWb08HXNiORRGV/H4aeqjdE/8jIIP8lCuRwqIiIiIiIiIiIiIiIiKZXwWtNXWHRDL9TKqAMlyy+to6dxHd1NRR8A8/TzZph/gUiXp2VUREREREWM9yulNNrdoRm+l07GGW/WeeKjc7jhlWweZTv8AylZGfyXzU1dNUUVRLR1cLop4JHRSxuHBY9p4cD9wQvxRERERERERERERERFziifM9scTS57iGta0clxPoAP39l9JG0rSqXRTblgWm9XB5NfbLPDJcGfSsm5mnH5SSPH5LLqIiIiIiIqKAXxLtCXaJbor/JbqfosOak5LbCG8NYZnH4iIf3ZxJwPZrmLVJEREREREREREREREWzfh16Gz65bo8Xt9TRedY8YlGR3hzm8sEFM5pjY72+eYxM49wXfQr6DOPdVREREREREWmfii7bRrht6qcusdA6bKdPPNvNF5TOqSooy0fFwfU8sa2QAd+qEAepUEhACoiIiIiIiIiIiIiIg7kcqcvwptt02jOgQ1AyKjMOR6kGK5yRvbw+mtzARSRn7ua50p/wCa0EctK3dRERERERERcZGNkaWPALT2II5BH0UBfiNbUZttet9VcMft/l4Pmb5bnYnxM4jpXl3M9F9GmNzuWj+rez3DgNTT2KIiIiIiIiIiIiIi2h8PjanU7ntcKKnvdulkwnFnx3PI5SCI5WB3MVJ1f+qZzSCB36GyEdwF9ANLBFTQMp4ImRRxNDGRsaGtY0DgNAHoAPQL9kRERERERERYj3Q7dsR3O6RXfTPKmMimlb8TaLh08vt1ewHyp2+/HctcP2mOcPcEfPBqpphmWjufXnTfPbS+23ux1Bp6iEnlrh6tkY70fG9pDmuHqCCrSRERERERERERERXHp3p/luqWa2fT/BbRNc75faplJR00Y/E93q5x/ZY0cuc49mtaSewX0PbTtteM7XdHrVpzYnMqbgf55fLkG8OuFe9oEkn2YOAxjfZjW+/JOZ0RERERERERFQjkcLT/AMQXY3bN02G/ypxCnpKLUjHaci2VDz5bLlTg8mind/ExvP4XHjs1ziIJ79YLzi96rcdyG2VFuudtqH0tZR1MZjlgmY4tcx7T3BBBBC6CIiIiIiIiIiIu5Z7PdMgulJZLJbqivuFfMynpaWmjMks8r3BrWMaO7nEkAAKc7w8dilv2xYr/AC5zqmgqdS7/AEwZWODg9lopnEH4SIjsXngGR49SA0fKOXbnIiIiIiIiIiIiotLt+vh749uctc2f4Cyls+plDTkMmcAynvUbB8sFQfRsgHZk3t+F3LeC2ETM8LyrT7J7hhmaWCss17tMxp62hq4+iWGQexHuCCCCOQQQQSDyvEI4PBRERERERERE4JXr4piWSZvkdvxLErFXXi8XWdtPR0VFCZZpnn2a0fbkk+gAJPACmw2DeHbY9uFBS6l6mU9LdtS6uHlg7SU9hY4HmKA+j5iCA+X27tYeOXP3fa0NAHHoOFyREREREREREREVCARwVr3ux2U6TbsMe8nJ6P8AROU0UJjtWSUcY+JpvUiOQek0PJPMbvTk9JaTyoSNyu0TWba5kbrRqJj5ltU8nFvv9C18lvrR7BshA6JPrG/hw49xw44T4I9kRERERERE4P0WZdt+1DWPdBkzbFpvjrzb4XhtwvlYHRW+gb7+ZLwep/HpG3l5+nHJE2m0XY5pNtOsbZrLStvmZVUPl3HJauICeQH8UcDe/kRc/stJLuAXOd242OAA7BVREREREREREREREXk5PimN5pYq3F8usVBebPcYzDV0NdTsngnYfZzHAg//AIo1tzvg52a6vqco2x39lpqCC92MXiZz6Z5+lPUnl8f0DZA4d/xtHZRn6raI6q6IX9+M6qYNdsdrmkhnxcBEM4H7UMw5jlb/AGmOIVjEcIiIiIirwVeWl2jep+tORR4tpdhN2yK4yEdTKKnLmQg/tSyHhkTf7T3AfdSW7ZPBxoaN0GTbnshbWyDh7MZsk7mxD34qaocF30LIuP8AmH0UluJYXiuB4/RYphmP2+yWa3xiKloKGnbDBE0fRrQBz7k+pPJPJXtoiIiIiIiIiIiIiIiIvGyrDsWzi0zWHMcctd8tk44lo7jSMqYX/vY8ELSvWPwgdtmfTT3PTysvGntfMS7yqGT4yh6j6nyJj1N/cyRrR7ALTHU/wetz2HzTT4LX43nNA3vH8JV/BVZH9qGfhgPp2bI5a15ntM3MafGQ5ZoXmlHFESHTstE08A/6sQczj81i2roaygndTV1LNTTNPDo5oyxw/eD3X49PHuEA59wv0pqSqrZ201FTy1Ezzw2OJhe537gO6yjhu1HcpqAYziOh2aV0UhAbObPNDAef+LI1rP8ANbJaY+D/ALo8xlimzebHcGoHDmR1bWCsquP7MNP1NJ+zpGrc/R7wfduWCTwXPUe53rUKtiPV5NU/4GgLh6Ewwnrd+50hafcFbq4lhGIYFZ4sewnGLVYbZCOI6S20kdNE3/CwAE/cr21VERERERERERERERERERFQgH1CAAei8m84hieRNLMgxi03Np9RWUUUw/1tKtGr257f693XW6H4DM49+XY5Rk/+NKTblt9oHdVFobgMLh7txyjB/wDGrts2HYjjjQ3HsWs9sA9BR0MUHH/Y0L1yARwU6R9AqoiIiIiIiIiIiIiIiIiIiIiIiIiIiIqHssaaublNDNB57fS6uakWzGp7rHJNRxVIke+ZjCA5wbG1x4BcB39fb0K9vMNYNNMA0+Gq2Y5fRWvE3RU07bpN1GJ0dQWiEgNBceovbx291YmDb1Nq2pOS0mH4XrfjlwvNe/y6SjMr4H1Eh9GRmVrQ5x9mg8n2CuDWPcpoboBS01Rq9qNa8dfW8mlppi+WqnaPVzIIg6QtB7F3T0g9uV3NJtfNINc8cqMr0ozu3ZDbqN3RVvp3OZJSu454mieGvj5AJHU0cgEjlftpVrhpTrfa6+96U5nR5HQWuq+Cq6ilZI1kU/SHdHL2t5PSQe3PYheLYt0mgGTYplOcWLU611lhwp/l364MbKIqF3fs4lg6vTt088/mrwwbUXCdSsSoM7wfIae62C5tc6kr4w5kcwa9zCR1gH8TXD09l70VXTTu6IZ43njnhrweB+S/ZEREREREREREREREREREXj5dlVgwjGLrmGU3OK32ey0ctfXVUp4bDBG0ue4/XsD29T6KDTVXXHTXckNdNctUMrghyutpaWxabYzPFK91HRMqonvlBDTGx/ktcOS4cvlnPHdqz5va1JuGSbENs+mVpZU111zyjtL3UlKOueq+Do4ovLawclznTTR8D3cArftuJYju53O6daOYnoXRaDVOlkDblkDa+AUt7usELoHBgjjiZ1SAMa4PeSR5z38kDh2Rdi+BYpu83D6z7i9cLLS5XV2q8NtlktV2YKqloonOl6P1L+Wny4o2MYHDgcvdx1dxd17080A2r4puN3EaE6xWq6G42Kots2M2aspZKOzVlVN5VMwCBxLC2Z7g1pA4HWB6LAWgOrO77avs8q7zjW320fyEucE99dltdc2tmPxgbDFMIhLz2/V9Lenk9j7rybrBWaL+FLZrDE15yDXjL/iiwd5X0bHgt+5BFJD/AO/91JlR7XcAu+2DFdu+okFU+y2K026KsNJWvpHGopmNc+TzYyCAZOtx/etZ9rmLaPaE74c8senuSwQYNUae2mqt9ZW374umnmq6uBrDHUSPLX+Y8tawAnkngevCkMa4OHI/cqoiIiIiIiIiIiIiIiIiKnPssIbttvN63PaZf7K6LUifD7XV1kdTdZaegFTJWxRjlkHeRnS3zOl59eSxo7Dnm18y2EaB3/RCr0gx3CMdsdbJaIrXT5I2x081whewN/nBk4a50juklx6gT1HurMxbw8aa0Z5otll+1Xq7zb9FrYyht1rdaWRMqpmTTTNnc/zT0EOki7AH+gb37rIFdtGo594tBu4pc4qKapp7X+i6my/AtcyoHw74eszdfI7OaeOk/g+6wxmnhh3OLUPKcu0I3I5Tpnac1lfNebPQwvexxe5znsY+OWPmPl7+lrgS3qI5IVzZD4aenp2zRbatP80rccpqu7wXm/XuSiZVVd4mia4NbKOpgawOLS1oPDegepLicna+7V6XWXblQ7cLJmcuLWijhttL8VHRNqXPpqNrQyLo62gclkZJ5/Z+6tDUTYlZM/uOh0M+dT02PaJw0kdNaRbmPbcnQmE9Uj+seX1CnYCA13qVtNU0tLX0ktHWQxzwTsdHLFI0OY9jhw5rgexBBIIPstNsR8L3Q7FNfqjVj4qrrcXY5tVbMLqW9dBRVYd1BxcXHzIWOLnRwubw1zvUgcLc9oAHAPKqiIiIiIiIiIiIiIiIiItO/ECxjXe3YhdNatO9yldpzjmEY/PUVVpoaNz5LnV9ZLOqUSNDS8mGJvLT0kk9+eFhLalie7XLtLsY3Zapbv8AJoMNoDUZFc8amhc99ZbaGSQvY6brADZWwH9j8Llg3R7XLVvWayXfOM78Sduk88t3qGUlgrWunkFP8rxI0NezoZzIWNbwf6MrYfdJp5uo0d0Ej1ept8d7bQ4fj0LJ2RUDmTX6unq3lkheZfl6hURRtHDulkQ+6/Ta9ojvc1Q06xTWjId6F+o4MjtM9fT2Spo3zeX5scjKWR7xIA9vJim6ekcjtz7rEdRZN7Dt4FLtFsm9nJrlWstX6Tul8bTubFbx5Dpuh0PmEvPSYRz1jvMPp3yBn163J6b69aDbQ6bclkmT5JerrPkOV3uImB81tkmb5dN08vLWRwUdS/gnuZSfRZL3Oau6oXvffontx00zm72G1vY285RHbZxH8XT+Y6V0Uh7njyaV4H/OKwq/U7WncbuZ1vprPvNqNG8IwWrNLbfNqIvhpXQkw8MY6WM9J8iWVzwXHlwHHccZn8OrcfqrlO3/ADzUjcZlEtwxvEK2Q27J62Dyn1dJFCX1B6ulvmtaQzpdxyS8tJJHA12sW6jczlmtGl2vd51DvVh0z1N1N/QFnxRr+mn/AETDLTxFz+3Dw7zulx93skPYcBS5tHAI+65IiIiIiIiIiIiIiIiIiLT7xQMa1Xz/AG6Q6aaS4ReskrckvtJHcI7bTOlMNJCXTdUnH4W+ayLufuu/uf0/zfCNhFVopo9h9zvt4/k7bsUgorXTOlldCRHHUyFrfYxtl6j9X/dajaBYVf8AGbFhWm2XeFIbzXwS01DcctvLA10j3zfrKubqpXdLWhxPBeeGtA5Wy3iiYNqzqrpFimk+lOE3q+/p3JIZrrJb6Yyx0lNC0hrpSOzGl8jXd/6sn2W3eIY3Q4ZiNkxG2sDKOx26mttO0e0UMTY2j+DQtLtk+kepUu7HXrcXqpg15sEt+rDbceddKQwumoXTk9UfV34EdPSt5/JWZuWxbXzQvfrRbtcP0QvGqeNVNiZbWUto63z0T/hzA9vyMkdGfV4d0FrhI4cg88drbvpnuEyXWjU/fprPpZWWC8uxuppsOw8MMtc97YA2Noj462noiEY6g1z3TPd0tA74a0+8Om55Jsvz/PdS9Kb5/tsra+tuNjgkdPFWsYwx8R/Dh3S8yuE5+ZpJDmkH0V15niO7bWbbhobtEpdNMvx+Otiiizu/V1sfFTUdNBUPbTxSuPAf0xxid455cRCOSXFeJuD2C6+aQW7SupwLUzO9Ybdi2R07qSwR2t4hscEZbJ5sTGzPDATGGngNHPHdSzsPUOQOAe65IiIiIiIiIiIiIiIiIqEgep4WqWn+/G0Z7Wa51UOBz0mPaJw1T57r+kmyC6PhdMAxjOgeX1CB3BLncctXS2a+IDZN22SZHjT9PajD6qwW2G6t+IuQqRUwOf0vcOI2dIbyw89+Q5WTP4olIzQ/Jtd6TRWsmstizKHEqWM3prTWl8UkhqA7yfkDWsj+Xg/0nr275f3Pbz8a216Z4nmlTjFTkd7zaWmis+P0tV5c84kja+R/V0O+VnWxvZpLnPYAO548bC98EeQ685BojkunX8n/AORmKtyXKbu+8CeG1ObTQzT0xaIh1mJ03ll4cOSxxA44WH714quTnG7hqvhu1PKLtpXbrh8A/KKq4tpg89YZz0CN4byXNABcQCQCQTwsrat7/wDFsA0+0hzvD8Frsql1injitFsNa2jmga4MB6z0PBc2SVkfA7E8kHhdDXHf1ftMtfKvb5p1t/vmpd/t1qguVYLRcOl8XW3rc3yxC8kNa6Il3I/GBwPf0NEfEHwXV3TzU7LbvhN5xC9aT0Mtdf7JcZGucGsZKQ1kga35i+F8Za5rS13HY8q3a7xIrfZtpFBuqvmlFTRx3vIHWK0WJ14aZKzpL+qcTeUOAPKn7dB/AO/fttti1/qr1hVoyq/Wz9Dz11sguFXRvl8z4Nz4hI+Nz+B1FnJBPA9PRaMY14pWfZ+y4XDTHZfm+WWeirZaFtxtla+aNzm9wHdFMQ1xaWuLeTx1Bbn6KZ3kmpmmVkzrLMBrsKud2jkllsVdIX1FG0SOawSEsYQ5zWh/HSOA8BXwiIiIiIiIiIiIiIiIisbXHUSn0l0ezPUuoc3/AHbsdZcY2u9HyxxOMbP8T+hv5qJC0VFw0g8Ky/ZDUvkdkWvmZfCRPPJllpWPIcQB3PV8LUDv/XD6r29W6GbYVq7Z6sE0jcp0GksPU0Hh97ZRmH2Hr8RHA4/Z/svS1I0okwHwdsYfVweXX3m/UWU1Xy8EirmeISf+g6FXftepX7x9yrdxGaSPbpfoNZaK2Y9FM0iOetgpw4yu57Hh7ZKh3oR/N2nkAq2Nr2p2BWXAtx+8bXSyXuvxbU3JH4l5Nup2yTinqvNkmZ8zmhrQyeBnVz2LR6lY9yu43jZ3h2LagbWN11BmeEZtWRVMOn92bDV1MXmMEhZVUbXPjLgWtjke0QvD+kDk9xsRqPUy69eJfovp7+iGW+g01x2myG7W5nAZb6sxGsdGQBwOHOo2fvKwLieQ3LVHXjcJuPx3dpZdGp6OuqaS2TVZglqbxRNL/LhiY+Rrw0MpoO8bXkl4AHbv1rbm9Dj3hgZlk78ckocw1TzZlhud9kqJZanIeh/xTp3OkJPAAnYQ35S4vPq4q+t0VlxjFKnZ9tRy68W+yWKxUFFfMnlrZ2w08YlewTPke7gDkx1fr7v+63R3K7ttIW7X9VMp0v1OxzI6+02E0obabiyofTzVrvhYHO6D2+eTkf3T9FoXtV0/v9q0lxtmL+JRjumTsikFdNiUD4XT09RM8MDX/r2uMrmtj7FoIJA/fMjQU7qSigpXzyTuhjbG6WU8veQAOpx9yfUrsIiIiIiIiIiIiIiIiIrez7T/AA7VHFK/Bs+sUN5sN0axlZQzOc1kwa8PaCWkHs5oPr7Kz7xtg0FyDHMTxC86aWuqsuCyCXHqF7pBDb3gg9TWhw6jy0E9fVz3+pXY1c246Ja8SWybV7T23ZNJZmzNoH1bpGmASlpkALHN7HoZ68+nZepl+jOmGfaexaU5hh1Dc8SgipoYrVL1CFkdP0+S0dJDgGdLeO/svyxLQ/SfA9PKzSfDsIt9pxK4MqY6q103W2OZtQC2bqd1dRLmngnnnjgDgALrY/t70WxbTSq0csenNngwmuMrqmyPh86mmMhDnlwkLiTyAQeeQQOOOArK0+2K7TtLsqhzbCtF7NR3qlk86lqZ5Z6v4aT2fEyd72McPZzQCPYhXxadAtILHn2QapWnBqGmyzKqZ9HeLs18hnqoX9HUwku4aD5bPwgfhCxxB4e+zGnkZLHt+xsujIIEhne0kfUOkIP7jyr9zfbfoZqNZcexrMtM7NX2jE5fOstvbEYKahdwB8kURa3jhoHBBH27leXqbtI25ay5Ocz1Q0rteRXt1PHSmsqpJg/yo+ehgDXgADqPoPdeXQ7INqdsxi7YXQaLWWCyXyopau40bJJwyplp+vyHOPmdXyebJwOePmPIXVsmwzaFjd6t+RWPQqwUlytdVFW0dQ185MU8bg5jwHSEEhwB7gjss9gce5Kqio78J/cqoiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiL/2Q=="

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/6.ae8528f.jpg";

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/7.ba48e2e.jpg";

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/8.fa2d3fc.jpg";

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/9.6d603bc.jpg";

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/_1021.27d8116.jpg";

/***/ }),
/* 331 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Recta.2d7c78b.eot";

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Recta.050baf2.otf";

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Recta.762434e.ttf";

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Recta.4c03c15.woff";

/***/ }),
/* 336 */
/***/ (function(module, exports) {

module.exports = "data:application/font-woff2;base64,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"

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(189)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(118),
  /* template */
  __webpack_require__(358),
  /* scopeId */
  "data-v-266e5812",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(188)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(356),
  /* scopeId */
  "data-v-23f5854f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(120),
  /* template */
  __webpack_require__(354),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(121),
  /* template */
  __webpack_require__(357),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(183)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(350),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(193)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(124),
  /* template */
  __webpack_require__(362),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(192)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(361),
  /* scopeId */
  "data-v-6b89aeae",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(190)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(126),
  /* template */
  __webpack_require__(359),
  /* scopeId */
  "data-v-395ebe7c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(185)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(127),
  /* template */
  __webpack_require__(352),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(186)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(353),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(195)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(129),
  /* template */
  __webpack_require__(364),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(187)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(355),
  /* scopeId */
  "data-v-1d661d96",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(184)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(132),
  /* template */
  __webpack_require__(351),
  /* scopeId */
  "data-v-0b1fcce8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 350 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inside"
  }, [(false) ? _c('div', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "inside-in",
    attrs: {
      "id": "page"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 351 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row progetti"
  }, _vm._l((_vm.filtrati), function(item, index) {
    return _c('div', {
      staticClass: "progetto col col-s12 m6",
      on: {
        "remove": function($event) {
          _vm.onRemove(index)
        }
      }
    }, [(item.link == '1') ? _c('router-link', {
      attrs: {
        "to": '/inside/progetto/p' + item.id
      }
    }, [_c('img', {
      attrs: {
        "src": '/site/images/p/' + item.id + '.jpg'
      }
    })]) : _vm._e(), _vm._v(" "), (item.link != '1') ? _c('img', {
      attrs: {
        "src": '/site/images/p/' + item.id + '.jpg'
      }
    }) : _vm._e(), _vm._v(" "), (item.stato != '') ? _c('el-tooltip', {
      staticStyle: {
        "float": "right"
      },
      attrs: {
        "content": item.stato,
        "placement": "top"
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("menu")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "titolo"
    }, [_vm._v(_vm._s(item.titolo))])], 1)
  }))
},staticRenderFns: []}

/***/ }),
/* 352 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "site-footer "
  }, [_c('div', {
    staticClass: "row container"
  }, [_c('div', {
    staticClass: "col col-s12"
  }, [_c('img', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "src": _vm.$root.urlsite + 'documenti/footerBM.png'
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 353 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "site-header"
  }, [_c('div', {
    staticClass: "row container"
  }, [_c('div', {
    staticClass: "col col-s8"
  }, [_vm._v("XX Congresso Nazionale SIGU")]), _vm._v(" "), _c('div', {
    staticClass: "col col-s4"
  }, [_c('a', {
    attrs: {
      "href": "http://www.sigu.net",
      "target": "blank"
    }
  }, [_vm._v("SIGU.NET")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/inside/contatti/segreteria-organizzativa"
    }
  }, [_vm._v("CONTATTI")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/home"
    }
  }, [_vm._v("HOME")])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 354 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "height": "450px",
      "overflow": "hidden"
    }
  }, [_c('img', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "src": _vm.$root.urlsite + 'documenti/backHome.png'
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 355 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row progetti"
  }, _vm._l((_vm.filtrati), function(item, index) {
    return _c('div', {
      staticClass: "progetto col col-s12 m6",
      on: {
        "remove": function($event) {
          _vm.onRemove(index)
        }
      }
    }, [(item.link == '1') ? _c('router-link', {
      attrs: {
        "to": '/inside/progetto/p' + item.id
      }
    }, [_c('img', {
      attrs: {
        "src": '/site/images/p/' + item.id + '.jpg'
      }
    })]) : _vm._e(), _vm._v(" "), (item.link != '1') ? _c('img', {
      attrs: {
        "src": '/site/images/p/' + item.id + '.jpg'
      }
    }) : _vm._e(), _vm._v(" "), (item.stato != '') ? _c('el-tooltip', {
      staticStyle: {
        "float": "right"
      },
      attrs: {
        "content": item.stato,
        "placement": "top"
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("menu")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "titolo"
    }, [_vm._v(_vm._s(item.titolo))])], 1)
  }))
},staticRenderFns: []}

/***/ }),
/* 356 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home row",
    attrs: {
      "id": "fwc"
    }
  }, [_c('div', {
    staticClass: "acol wideDesign"
  }, [_c('news', {
    attrs: {
      "image": "2031.jpg",
      "link": "https://ilgiornaledellarchitettura.com/2025/12/03/a-torino-il-laboratorio-hi-tech-e-in-un-garage/",
      "titolo": "IAAD Garage in Il Giornale dell'Architettura "
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("IAAD establishes new educational spaces inside the former Ceat building in Turin, a space designed by Dap Studio that is now taking on a new lease of life, hosting hi-tech laboratories ready to support students in their design courses.")])]), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign",
    staticStyle: {
      "clear": "left"
    }
  }, [_c('news', {
    attrs: {
      "image": "2030.jpg",
      "link": "https://www.theplan.it/architettura/riuso-lambrate-dap-studio-milano",
      "titolo": "A courtyard that becomes a city"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The Riuso Lambrate project has been published in The Plan and featured in several architecture magazines."), _c('br'), _vm._v("The wide media coverage confirms the strong interest in themes of reuse and transformation of the existing built environment.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign"
  }, [_c('news', {
    attrs: {
      "image": "2029.jpg",
      "link": "",
      "titolo": "Civic Center and urban regeneration in Malnate"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Work continues on the new Civic Centre, a project that includes numerous services for citizens, a large and functional library, and new office space. The project aims to create a landmark for the community, combining functionality, accessibility, and spatial quality")])])], 1), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2025.jpg",
      "link": "/inside/progetto/p143",
      "titolo": "Endine, new office building"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("An architectural enclosure brings together workspaces and open courtyards, amplifying the presence and volumetric perception of the building")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2024.jpg",
      "link": "https://www.dedalominosse.org/ita/#",
      "titolo": "Dedalo Minosse Award"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("2025 Edition: Mezzolombardo Library included in the selected projects for the exhibition at the Basilica Palladiana")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2023.jpg",
      "link": "/inside/progetto/p141",
      "titolo": "Design competition for the Grigoletti Primary School in Pordenone"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The project for the new Grigoletti Primary School proposes an open, experiential, and inclusive educational model, capable of redefining the relationship between school and society")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2021.jpg",
      "link": "",
      "titolo": "Strategies for the Regeneration of the Built Environment in Milan"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The studio proposes the redevelopment of a centrally located building through a corner void intervention that enhances its legibility and openness. The façades, contemporary yet inspired by Milanese tradition, transform the volume into an identity-defining element within the urban fabric.")])]), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign",
    staticStyle: {
      "clear": "left"
    }
  }, [_c('news', {
    attrs: {
      "image": "2018.jpg",
      "link": "/inside/news/n2018",
      "titolo": "Urban regeneration of the historic center and new centralities"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("As part of a broader urban regeneration strategy for the center of Parabiago, DAP studio is developing a unified project articulated into areas with specific identities and functions. Within this framework, two key interventions are being developed: the redevelopment of Piazza Maggiolini, at the heart of the historic center, and the new entrance square to the Cultural Center in the former Rede hosiery factory area.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign"
  }, [_c('news', {
    attrs: {
      "image": "2019.jpg",
      "link": "https://www.artribune.com/progettazione/2025/04/intervista-elena-sacco-dap-studio/",
      "titolo": "Designing Within the Existing: DAP Studio on Artribune"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Elena Sacco, partner at DAP Studio, was interviewed by Artribune to discuss the studio’s approach to working with existing architecture — a process rooted in dialogue with the urban context and the creation of new relationships.")])])], 1), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2012.jpg",
      "link": "https://vimeo.com/1063490318",
      "titolo": "TEMPORARY LIVING. NEW RESIDENCES FOR UPTOHOME "
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The new UPTOHOME residence, an accommodation facility located in the east of Milan, is nearing completion. All the apartments of UPTOHOME have been designed by DAP studio, which has been working for many years on temporary living in its various forms."), _c('br'), _vm._v("At this link some phases of the construction site’")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2013.jpg",
      "link": "https://villamaddalena.info/",
      "titolo": "IN THE HEART OF MONFERRATO"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("DAP studio has carried out the renovation of a villa designed by the firm in the 1990s, reconfiguring it to accommodate its new use as a holiday home. The intervention included the swimming pool, garden, interior furnishings, and sustainability features, with photovoltaic panels on the roof and an electric car charging station.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2016.jpg",
      "link": "https://ntplusentilocaliedilizia.ilsole24ore.com/art/immobiliare-sfida-rigenerazione-progettare-nuovo-sull-esistente-AGZFFUcB?refresh_ce=1",
      "titolo": "THE CHALLENGE OF REGENERATION: DESIGNING THE NEW ON THE EXISTING  "
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("When new meets existing, new architecture is born, writes Maria Chiara Voci in Real Estate 24, and she addresses this issue by illustrating the redevelopment of the Ex Banco di Sicilia in Turin, whose works are currently underway. The project was developed by DAP studio with 3+Progetti, Prof Gasparoli and Projema Engineering.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2010.jpg",
      "link": "https://siat.torino.it/tour/addition-in-architecture-il-progetto-del-nuovo-nellesistente-giornate-di-studio-e-call-aperta-per-giovani-professionisti/",
      "titolo": "ADDITION IN ARCHITECTURE"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("DAP studio is speaking on 28/11 at the conference, promoted by SIAT, at the Faculty of Architecture, Salone d’Onore, Castello del Valentino. The conference aims to offer a selection of the projects in Italy and Europe that, by grafting new forms and materials onto existing buildings, generate new situations of balance.")])]), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign",
    staticStyle: {
      "clear": "left"
    }
  }, [_c('news', {
    attrs: {
      "image": "2008.jpg",
      "link": "https://archello.com/news/archello-awards-2024-longlist-library-building-of-the-year",
      "titolo": "THE MEZZOLOMBARDO LIBRARY ON THE ARCHELLO AWARDS LONGLIST"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The Library of Mezzolombardo has been selected, along with five other projects, for the Library Building of the Year category in the 2024 edition. The winners will be announced on 31 January 2025, after an evaluation by an international jury and the readers' vote through the platform: vote for us!")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign"
  }, [_c('news', {
    attrs: {
      "image": "2009.jpg",
      "link": "https://gangemi.com/prodotto/yearbook-8/",
      "titolo": "YEARBOOK 2023"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The Mezzolombardo Library is among the projects selected and published in the 2023 edition of the Yearbook, a publication promoted by the CNAPPC and edited by Alessandra Ferrari.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign",
    staticStyle: {
      "clear": "left"
    }
  }, [_c('news', {
    attrs: {
      "image": "2007.jpg",
      "link": "https://cultlabtorino.com/cult-hub/",
      "titolo": "ARCHITECTURE EVENINGS IN TURIN: PROJECTS FOR THE PUBLIC CITY"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("On the 17th of October 2024 in Turin at @ultraspazio_club we will participate in Le Serate di Architettura by @cultlabtorino, in order to explore how public architecture can revitalise contemporary cities.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign"
  }, [_c('news', {
    attrs: {
      "image": "2003.jpg",
      "link": "https://www.mediterraneiinvisibili.com/edizione-2024/",
      "titolo": "LA BIENNALE DELLO STRETTO 2024"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Our urban regeneration project for the municipality of Garbagnate will be presented until the 14th of December at the Biennale dello Stretto 2024, curated by Mariangela Cama, Alfonso Femia and Francesca Moraci.")])])], 1), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2004.png",
      "link": "https://drive.google.com/file/d/1ICMAv9P3cyjv9xS6ukNeKNASLMZPo_ML/view",
      "titolo": "THE LIVELY SQUARE IN A SHORT FILM"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("At the Biennale dello Stretto 2024 will also be presented the Alberto Danelli's short film Piazza Giardino, winner of the ‘Contemporaneamente’ video contest launched by Ordine degli Architetti di Genova, shortlisted for the 2021 Dezeen Awards and among the finalists of the Venice Architecture Short Film Festival ‘Living together again’")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2000.jpg",
      "link": "/inside/progetto/p138",
      "titolo": "MEZZOLOMBARDO LIBRARY"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("DAP Studio has conceived a versatile space that facilitates the simultaneous performance of different activities. With more than 1000 square metres at its disposal, the facility houses the library proper, a modern multi-purpose hall and study rooms open 24 hours a day.")])]), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign",
    staticStyle: {
      "clear": "left"
    }
  }, [_c('news', {
    attrs: {
      "image": "1097.jpg",
      "link": "/inside/progetto/p137",
      "titolo": "REDEVELOPMENT OF THE FORMER CASERMA GARIBALDI IN VARESE"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The executive project for the second lot of the new Cultural Hub in Varese has been completed. The former Garibaldi Caserma will house spaces and services for culture, education, leisure, and social activities")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign"
  }, [_c('news', {
    attrs: {
      "image": "1098.jpg",
      "link": "/inside/news/n1098",
      "titolo": "GINORI MUSEUM, CONSTRUCTION SITE STARTS"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("With the opening of the  site to the construction company on May 21, the renovation of the Museo Ginori designed by DAP Studio in team with 3+Progetti and Projema Engineering, is now in full swing")])])], 1), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1095.jpg",
      "link": "/inside/news/n1095",
      "titolo": "LIBRARY CRP TORINO, WORK IN PROGRESS"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Renovation works are underway on the former Banco di Sicilia, a protected building in the center of Turin, for the construction of the new Library of the Regional Council of Piedmont")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1093.jpg",
      "link": "/inside/progetto/p134",
      "titolo": "CULTURAL CENTRE MARCONI"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The Cultural Centre in piazza Marconi, heart of Pero's urban system, is the first piece of the overall urban regeneration project commissioned to DAP studio. It will house cultural spaces and  services for the community: library, exhibition spaces, auditorium, bar, course spaces and coworking")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1088.jpg",
      "link": "https://anci.lombardia.it/dettaglio-news/20227151641-spazio-alla-scuola-presentati-i-progetti-dei-comuni-vincitori-del-bando-regionale/",
      "titolo": "TRAVAINI SCHOOL WINS REGIONAL FUNDING"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The conference at Anci headquarters in Milan, presents the Travaini elementary school in Parabiago designed by DAP studio, one of the 9 projects accepted for funding against 120 applications: a school conceived as a real Civic Center, a reference point for the community of students and a place open to the city.")])]), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign",
    staticStyle: {
      "clear": "left"
    }
  }, [_c('news', {
    attrs: {
      "image": "1086.jpg",
      "link": "/inside/progetto/p135",
      "titolo": "Strategic Urban Project for the public space"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The Strategic Urban Project for the public space, commissioned to DAP studio by the Municipality of Pero, anticipated the revision of the PGT and expresses a vision of the future city.Thanks to this project, the Administration has been able to access to PNRR funds")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign"
  }, [_c('news', {
    attrs: {
      "image": "1087.jpg",
      "link": "https://www.ilqi.it/convegni/220526e01",
      "titolo": "Progetti & Cantieri d’Italia 2022, auditorium Assimpredil Milan"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The conference illustrates the main real estate projects in progress across Italy. "), _c('br'), _vm._v("Elena Sacco is invited to present the Rede Cultural Centre, one of the latest projects by DAP studio. A regeneration project for a 14,000-square-meter industrial building that will house services for citizens, spaces for culture and leisure.")])])], 1), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1085.jpg",
      "link": "/inside/progetto/p136",
      "titolo": "CENTRO CULTURALE REDE"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("DAP studio designs the transformation of the Calzificio Rede,bridge-shaped industrial building: a large multifunctional civic hub that will house services, cultural and leisure spaces.")])]), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign",
    staticStyle: {
      "clear": "left"
    }
  }, [_c('news', {
    attrs: {
      "image": "1084.jpg",
      "link": "https://issuu.com/dida-unifi/docs/dieci_progetti_per_la_qualita_abitativa_maria_de",
      "titolo": "Ten Projects for Housing Quality"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Abitare Toscana and InvestiRE SGR promoted the publication of the book “Ten Projects for Housing Quality,” edited by Maria De Sanctis. DAP studio is one of the selected firms with a proposal developed in collaboration with Claudio Bossi of the social cooperative La Cordata.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign"
  }, [_c('news', {
    attrs: {
      "image": "1082.jpg",
      "link": "https://www.arkitectureonweb.com/en/-/projects/fuori-dalle-righe",
      "titolo": "Fitting room n. 16 on archweb"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The Camerino designed by DAP studio for the Arcimboldi theater published on Archweb")])])], 1), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1079.jpg",
      "link": "https://interioresminimalistas.com/tag/dap-studio/",
      "titolo": "VILLA EN SICILIA: FUSIONAR ARQUITECTURA Y NATURALEZA"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Spanish magazine Interiores Minimalistas, which covers design and interior architecture, publishes the interiors of the villa in Sicily")])]), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign",
    staticStyle: {
      "clear": "left"
    }
  }, [_c('news', {
    attrs: {
      "image": "1076.jpg",
      "link": "https://www.mediterraneiinvisibili.com/",
      "titolo": "Mediterranei Invisibili. La Biennale dello Stretto"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("DAP studio participates with the project Villa in Sicilia in the “Biennale dello Stretto” 2022, a multidisciplinary event that includes contemporary art exhibitions, performances, workshops and cultural events.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign"
  }, [_c('news', {
    attrs: {
      "image": "1083.jpg",
      "link": "https://www.youtube.com/watch?v=J06e5uio45c",
      "titolo": "Encuentros"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Elena Sacco meets Giorgio Tartaro and  tells about DAP studio's interpretation of wood in design at Encuentros by Finsa. ")])])], 1), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1075.jpg",
      "link": "https://www.dezeen.com/awards/2021/shortlists/media/architecture-video-of-the-year/",
      "titolo": "Shorlisted Deezen Awards 2021"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The video Piazza Giardino by Alberto Danelli  has made it onto the Dezeen Awards 2021 shortlist. From over 4.700 entries from 87 countries to Dezeen Awards, the project is one of 5 videos  in the running  in the \"media\" category")])]), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign",
    staticStyle: {
      "clear": "left"
    }
  }, [_c('news', {
    attrs: {
      "image": "1071.jpg",
      "link": "#!",
      "titolo": "Regional Council Library of Turin "
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("A new project for the promotion of culture in Turin on behalf of the Regional Council. The former Banco di Sicilia, a building  protected by the Superintendence of Cultural Heritage  in the heart of the city, will become the new Library. ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign"
  }, [_c('news', {
    attrs: {
      "image": "1072.jpg",
      "link": "/inside/progetto/p130",
      "titolo": "Quality of Living. #ViviBusto2030 admitted for funding"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Social housing, culture, public life, mobility: # ViviBusto2030, the project by DAP studio for Busto Arsizio, has been admitted to the funding available by the National Innovative Program for the Quality of Living.")])])], 1), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1069.jpg",
      "link": "https://www.marieclaire.com/it/casa/case-arredamento/a36047963/dapstudio-architettura-sicilia/",
      "titolo": "A house in Sicily:: former tool shed, today a delicate domestic eden "
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Marie Claire writes about the Villa in Sicily \"On one side the Ionian Sea, on the other Etna. It is on these ancient dry stone terraces that the prohect by  DAP Studio has given life to the hospitable nest of a successful IT entrepreneur ... \"")])]), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign",
    staticStyle: {
      "clear": "left"
    }
  }, [_c('news', {
    attrs: {
      "image": "1067.jpg",
      "link": "#!",
      "titolo": "Best Internationl Houses"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Villa in Sicilia by DAP studio is included in the Best International Houses exhibition, organized by Platform at the same time as the Architecture Biennale in Venice. ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign"
  }, [_c('news', {
    attrs: {
      "image": "1068.jpg",
      "link": "https://www.teatroarcimboldi.it/fat-event/vietato-lingresso/",
      "titolo": "Vietato l'ingresso"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("DAP studio is one of the designer invited by the Arcimboldi Theater to design the 17 dressing rooms: 17 places where magic is born and which will be transformed with a heterogeneous proposal, just like the great artists who live there: actors, singers, dancers, musicians. An unprecedented project that allows the theater to reopen to the public in an unconventional way, after a year of forced closure.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign",
    staticStyle: {
      "clear": "left"
    }
  }, [_c('news', {
    attrs: {
      "image": "1061.jpg",
      "link": "/inside/progetto/p130",
      "titolo": "#viviBusto 2030"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Social housing, culture, public life, mobility: # ViviBusto2030 is the name of the project  by DAP studio, made for the municipality of Busto Arsizio. It involves more than 18,000 square meters of surface, distributed in 5 areas of the city centre that will undergo interventions of redevelopment and regeneration. ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign"
  }, [_c('news', {
    attrs: {
      "image": "1062.jpg",
      "link": "/inside/progetto/p127",
      "titolo": "A school open to the city"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("DAP studio’s project is among the 5 selected in Petriolo as part of the competition for the building of a new school, a place of learning for children but also a real civic center open to the whole city. ")])])], 1), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1058.jpg",
      "link": "/inside/progetto/p129",
      "titolo": "Villa in Sicily, an observatory on the landscape "
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Surrounded by the amazing landscape of north-eastern Sicily, the project by DAP studio transforms a former warehouse into an elegant hospitable nest. With a rooftop swimming pool. ")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1064.jpg",
      "link": "/inside/news/n1064",
      "titolo": "I MAESTRI DELL'ARCHITETTURA / COLLECTOR'S EDITION"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The issue dedicated to DAP studio has been published.  “I maestri dell’architettura” is a series of collectible illustrated monographs, on the protagonists of contemporary architecture in Italy and abroad. Each volume of this editorial project, curated by Angelica Di Virgilio, addresses the work of a different architect through interviews, drawings, photographs, descriptions.  The monographs are also available online at www.hachette-fascicoli.it")])]), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign",
    staticStyle: {
      "clear": "left"
    }
  }, [_c('news', {
    attrs: {
      "image": "1055.jpg",
      "link": "https://vimeo.com/434340070",
      "titolo": "VENICE ARCHITECTURE SHORT FILM FESTIVAL"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The garden-square designed by DAP studio is the subject of a short film, written and directed by Alberto Danelli, which placed among the 20 finalists of the Venice Architecture Short Film Festival 2020, organized by ArchiTuned . The theme of the International Festival, Living together again, is well suited to this redevelopment project. The 20 selected films were screened from the 1 st to 5 th of September in Venezia at the Cloister of San Francesco della Vigna and the Pavilion in the Giardini della Biennale.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign"
  }, [_c('news', {
    attrs: {
      "image": "1056.jpg",
      "link": "#!",
      "titolo": "IN/ARCHITETTURA AWARD 2020"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Honourable mention in the Urban Regeneration category to the Teca Theater, the Music Center, designed by DAP studio, which also includes outdoor areas  of 7 thousand square meters The Award Ceremony of the In/Architettura 2020 Lombardia and Emilia Romagna Awards took place in Milan on the 15 th  of October. ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign",
    staticStyle: {
      "clear": "left"
    }
  }, [_c('news', {
    attrs: {
      "image": "1052.jpg",
      "link": "https://www.domusweb.it/it/architettura/gallery/2020/10/29/a-garbagnate-milanese-un-vuoto-urbano-diventa-la-nuova-piazza-di-quartiere.html",
      "titolo": "PIAZZA-GIARDINO SU DOMUSWEB"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("DAP studio  redesigned an abandoned suburban area of 2500 square meters, making it a new landmark for the town of Garbagnate Milanese.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign"
  }, [_c('news', {
    attrs: {
      "image": "1053.jpg",
      "link": "https://www.archilovers.com/projects/269600/palestro-3.html",
      "titolo": "BEST ARCHILOVERS 2020"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Palestro 3 Residence designed for Reale Immobili is one of the  Best Archilovers 2020")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign",
    staticStyle: {
      "clear": "left"
    }
  }, [_c('news', {
    attrs: {
      "image": "1051.jpg",
      "link": "https://www.conventodicampo.it/index.html",
      "titolo": "IDEAS FOR THE EX CONVENT"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Paolo Danelli and Carlo Alberto Maggiore are the tutors of the design workshops for the redevelopment of the Campo Convent. This is the conclusion of a participatory process, coordinated by Avventura Urbana, for the reconversion of the Convent of Campo Lomaso (Trento) which involved institutions, associations and inhabitants of the valley.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign"
  }, [_c('news', {
    attrs: {
      "image": "1050.jpg",
      "link": "https://bigsee.eu/via-monviso-garden-square-garbagnate-milano/",
      "titolo": "BIGSEE AWARD ARCHITECTURE 2020"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("BigSEE Award 2020 to DAP studio for the square-garden project. BIG SEE is a creative platform that promotes creative excellence in South Eastern Europe. Bringing together 19 countries and 350 million people, BIG SEE represents a unique forum for the discussion and development of the cultural, economic and political role of this area of the planet.")])])], 1), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1045.jpg",
      "link": "/inside/progetto/p108",
      "titolo": "SOCIAL HOUSING SAMPIERDARENA, THE RED WIRE OF LIVING "
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The new Social Housing residence designed by DAP studio on behalf of DeA Capital opens to the public. \"Sampierdarena\" is an initiative by the Liguria Social Housing Fund that has enabled the conversion between a former office building and the realisation of comfortable apartments accessible to all. The welcoming hall and the common spaces are perfectly suitable for small gatherings and community activities, giving the opportunity to the inhabitants to write a new life chapter together in this ideal place. The colour, like a red wire of living, accompanies the spaces of relationship from the hall on the top floor.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1044.jpg",
      "link": "/inside/progetto/p87",
      "titolo": "VIA MONVISO GARDEN-SQUARE"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The construction works for via Monviso Garden-Square in Garbagnate have been completed.  When we were asked to redevelop the area, we wondered about the real/intrinsic nature of this site in a state of decay, in which only trees have been able to last despite the abandonment . And it is precisely from these trees that we started designing our project, integrating them into a design in which the image of the garden and the idea of the square can merge.  ")])]), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign",
    staticStyle: {
      "clear": "left"
    }
  }, [_c('news', {
    attrs: {
      "image": "1034.jpg",
      "link": "/inside/progetto/p14",
      "titolo": "RE-READINGS, RIBA PUBLISHING"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Rereadings  is a testament to the growing interest and demand for clarification of the remodelling, adaptation and transformation processes within the existing built environment.  The book explores how the remodelling of existing buildings is a sustrainable and viable alternative to the construction of new buildings. Elsa Morante Library by DAP studio, is one of the case studies analysed by the authors Graeme Brooker and Sally Stone ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign"
  }, [_c('news', {
    attrs: {
      "image": "1046.jpg",
      "link": "#!",
      "titolo": "ITALIAN ARCHITECTURE OF THE THIRD MILLENNIUM"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The generation of Italian architects who came after the \"golden age\" of the 60s and 70s, according to a widespread opinion, seems to have lost the ability to influence the culture of the project. With the new millennium, a different way of approaching the project towards the environment in which society lives and works has emerged. The author proposes an itinerary through 10 Italian regions and presents a selection of projects, including some buildings by DAP studio. ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign",
    staticStyle: {
      "clear": "left"
    }
  }, [_c('news', {
    attrs: {
      "image": "1041.jpg",
      "link": "#!",
      "titolo": "SCALO FARINI, 5 TEAMS SELECTED DAP STUDIO IS IN THE GRIMSHAW’S TEAM "
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The first phase of the competition launched by Fs Sistemi Urbani and Coima for the redevelopment of the Farini and San Cristoforo railway yard is closed. Names of worldwide fame together with important Italian names were selected by the jury chaired by Perrault. Sir Nicolas Grimshaw, one of the masters of contemporary British architecture, believes in the potential of a British-Italian team, which brings together all the expertise: the experience in the fields of urban regeneration of Urban Silence, the great knowledge of Elioth and the competences of the Italian firms Antonio Perazzi, Sec and Dap studio ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign"
  }, [_c('news', {
    attrs: {
      "image": "1042.jpg",
      "link": "https://www.theplan.it/webzine/architettura-italiana/centro-della-musica-a-cassano-d-adda-dap-studio",
      "titolo": "THE MUSIC CENTER ON THE PLAN"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The Center for Music at Cassano d’Adda expresses an idea of architecture as a way of creating a place of exalted functions and public significance, Francesco Pagliari writes on The Plan. The pictures are by Filippo Romano, the model was made by Alessandro Battistella")])])], 1), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1037.jpg",
      "link": "/inside/progetto/p126",
      "titolo": "R&D REGAS CENTER"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The strategic importance that Regas attributes to the Research and Development sector led to the acquisition of the former Snam Rete Gas building in Treviglio and the surrounding site to transform it into its R&D Center. The site has a total area of 13,000 square meters and includes a building entirely surrounded by a large park. The choice of a green location underlines the company's growing attention to nature and the environment. DAP studio has been invited to participate in the competition for the construction of the new headquarters.")])]), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign",
    staticStyle: {
      "clear": "left"
    }
  }, [_c('news', {
    attrs: {
      "image": "1038.jpg",
      "link": "#!",
      "titolo": "ARCHICHAT NIGHT"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The Archichat Night event, held at the Fabbrica del Vapore, organized by the RebelArchitette team and thanks to the hospitality of the Viafarini association and under the patronage of the Order of Architects of Milan, was an opportunity for a rich in-depth analysis on the diversity of approaches to contemporary architecture thanks to the intervention of five Milanese lecturers. Laura Berni (Lascia la scia), Selina Bertola (Nomade), Silvia Calatroni (SdArch), Elena Sacco (DAP studio) and Isabella Inti (Tempo Riuso) illustrated their educational and professional path together with their most significant projects.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign"
  }, [_c('news', {
    attrs: {
      "image": "1040.jpg",
      "link": "http://www.ediliziaeterritorio.ilsole24ore.com/art/progettazione-e-architettura/2018-09-13/a-cassano-d-adda-centro-la-musica-firmato-dap-studio-144604.php?uuid=AELzjjrF",
      "titolo": "DAP STUDIO ON EDILIZIA E TERRITORIO"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("In Cassano d’Adda the municipal Center for Music is signed by Dap studio, Mariagrazia Barletta writes in her article on Edilizia e Territorio, daily newspaper of Il Sole 24 Ore")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign",
    staticStyle: {
      "clear": "left"
    }
  }, [_c('news', {
    attrs: {
      "image": "1031.jpg",
      "link": "#!",
      "titolo": "MILAN CAPITAL OF THE MODERN"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The book, edited by Lorenzo Degli Esposti, investigate the relationships between modern architecture and the city of Milan, between single and specific works and the large scale of the urban territory. In addition to the map of 99 \"classic\" modern architectures, the book proposes other 77  projects built after 2000, including some DAP studio works.  ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign"
  }, [_c('news', {
    attrs: {
      "image": "1033.jpg",
      "link": "/inside/progetto/p125",
      "titolo": "URBAN CENTER COMPETITON, MILAN"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("DAP studio is among the architectural offices invited to the competition for the new Urban Center at the Milan Triennale. The jury for the selection of candidates (composed of: Stefano Boeri, president of  La Triennale Foundation in Milan; Alberto Artioli, director of the Foundation; Lorenza Baroncelli, curator of the Architecture, Urban and City Regeneration Sector; Paolo Brambilla, representative of the Milan Architects Order; Cino Zucchi, President of the jury) has chosen seven design groups.")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "acol shortDesign"
  }, [_c('news', {
    attrs: {
      "image": "2032.jpg",
      "link": "https://vimeo.com/1168188914?share=copy&fl=sv&fe=ci",
      "titolo": "Reuse Lambrate between construction site and shots by Marco Introini"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Alberto Danelli’s video narrates the building's transformation from a production space to a residence, alternating images of the construction site with behind-the-scenes footage from Marco Introini’s photo shoot. Two distant moments that, in the end, converge until they overlap. The result is a powerful contrast: on one side, the construction site, a living organism advancing from the depths; on the other, the staged life of the photographs, composed of carefully positioned figures.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2028.jpg",
      "link": "/inside/progetto/p144",
      "titolo": "Ex Cinema Corso. Contemporary Art Incubator"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The former cinema is transformed into a Laboratory for Contemporary Art experimentation: a flexible, multifunctional space capable of hosting visual arts, performances, screenings, and participatory events. The project integrates technological infrastructure suited to contemporary artistic practices while enhancing the historic identity of the former cinema.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2027.jpg",
      "link": "",
      "titolo": "Cultural center, Levico Terme"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("DAP Studio is working on the project for the new Cultural Center, an opportunity to respond organically to the community’s needs  and, at the same time, strengthen Levico Terme’s role as a hub for cultural production and enjoyment, also in relation to the tourist flows that affect the town for most of the year.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2026.jpg",
      "link": "/inside/progetto/p145",
      "titolo": "Lambrate. A Reuse Project"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Within the context of urban regeneration in East Milan, a building located within a courtyard has been transformed from a workshop into temporary residences, enhancing interior spaces, outdoor areas, and overall architectural quality.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2022.jpg",
      "link": "https://www.rigenerareggioemilia.it/i-selezionati-del-premio-architettura-rigenera-ii-edizione/",
      "titolo": "DAP studio selected as one of the ten national finalists for the Rigenera Award 2025"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The Jury of the Rigenera Award has selected the ten national finalists for the second edition of the competition. The designers will present their projects to the public and the commission on April 7, 2025.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2020.jpg",
      "link": "",
      "titolo": "Exploring Architectural Practices and Visions – Seminar in Barone Canavese"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("DAP studio is one of eight practices invited to the seminar held on May 24–25 in Barone Canavese, curated by Davide Derossi, Franco Lattes, and In/Arch Piemonte. An opportunity for dialogue among architects on practices and visions of contemporary architecture.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2011.jpg",
      "link": "https://www.architettinovaravco.it/page/OPEN_Architettura_aperta_2025._SPAZI_PUBBLICI_E_PRIVATI_IN_DIALOGO-1%C2%B0_incontro_DAP_STUDIO%3A_ELENA_SACCO%2C_PAOLO_DANELLI_5299",
      "titolo": "PRIVATE AND PUBLIC SPACES IN DIALOGUE"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("On Thursday 20 February, DAP studio will inaugurate the cycle of meetings promoted in Verbania by the Order of Architects, in collaboration with the Landscape Museum Study Centre, as part of the OPEN Architecture 2025 event.  We will talk about public projects but also discuss the role of private interventions in the construction of public spaces.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2014.jpg",
      "link": "/inside/progetto/p140",
      "titolo": "REHEARSAL HALL OF THE OPERA HOUSE OF ROMA CAPITALE"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The design proposal developed as part of the competition aims to create a technical-educational hub linked to the Teatro dell'Opera di Roma. The plan includes the construction of a stage design rehearsal room serving the Theater, which can also be open to the local community.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2015.jpg",
      "link": "https://www.artribune.com/progettazione/architettura/2024/11/savona-rigenerazione-capitale-cultura-2027/",
      "titolo": "NEW ROUTES FOR CULTURE"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("With the project ‘New routes for culture’, directed by Paolo Verri, Savona is competing for the title of Italian Capital of Culture 2027. The article in Artribune talks about Palazzo della Rovere and DAP studio, which is overseeing the interior design and the integrated identity and image project.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2002.jpg",
      "link": "https://www.dapstudio.com/site/inside/news/n1099",
      "titolo": "THE LIVELY SQUARE IN A SHORT FILM "
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("At the Biennale dello Stretto 2024 will also be presented the Alberto Danelli's short film Piazza Giardino, winner of the  ‘Contemporaneamente’ video contest launched by Ordine degli Architetti di Genova, shortlisted for the 2021 Dezeen Awards and among the finalists of the Venice Architecture Short Film Festival ‘Living together again’")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2006.jpg",
      "link": "https://architettibergamo.it/racconti-di-architettura-dap-studio-housing-sociale-come-strumento-di-rigenerazione-urbana/",
      "titolo": "RACCONTI DI ARCHITETTURA. DAP STUDIO: HOUSING SOCIALE COME STRUMENTO DI RIGENERAZIONE URBANA"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The webinar of the evening that hosted Elena Sacco and Michele Cortinovis in the  Racconti di Architettura Cycle is available on the website of the Ordine degli Architetti PPC di Bergamo")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2005.jpg",
      "link": "https://www.presstletter.com/2024/10/architects-meet-in-lecce-hyperregionalism/",
      "titolo": "HYPER REGIONALISM. ARCHITECTS MEET IN LECCE"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("From the 24th to 26th of October we participate in the event organized by the Associazione Italiana di Architettura e Critica (Aiac) in Lecce. Our Library of Mezzolombardo is exhibited at the church of Santa Maria di Ognibene, within the HyperRegionalism exhibition.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2001.jpg",
      "link": "https://www.thebrief.city/stories/progettare-la-citta-pubblica-il-metodo-dap-studio/",
      "titolo": "DESIGNING THE PUBLIC CITY. THE DAP STUDIO APPROACH"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Claudia Brivio interviews Elena Sacco and Paolo Danelli, founders of DAP studio. From their origins to their recent collaborations with municipalities, they talk about their method and experience in designing the public city, thanks also to the push for urban regeneration provided by the Pnrr and Pinqua.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1099.jpg",
      "link": "https://www.comune.savona.it/it/aree-tematiche/interventi-e-programmi-di-riqualificazione-urbana/piano-di-valorizzazione-palazzo-della-rovere/programma-di-valorizzazione.html",
      "titolo": "PALAZZO DELLA ROVERE IN SAVONA"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The renovation of Palazzo della Rovere, which will host a new cultural center and library, funded by the PNRR, has been initiated. DAP Studio was commissioned to design the interior spaces and and the integrated identity and image project for the Center.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1096.jpg",
      "link": "https://www.silvanaeditoriale.it/libro/9788836656257",
      "titolo": "ATLANTE DELLE ARCHITETTURE NELLA PROVINCIA DI VARESE"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Three projects by DAP Studio have been included by Luciano Crespi among the must-see places selected in his Atlante")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1094.jpg",
      "link": "https://www.dapstudio.com/site/documents/Pesaro-2024_MOSTRA_locandina_programma_50x70.pdf",
      "titolo": "PESARO CAPITALE DELLA CULTURA 2024"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("DAP studio's Elsa Morante Civic Library will be part of the selection of projects “Architectures for the Community of the Present,”  exhibition organized by the National Council of Architects with the Pesaro Architects Association, opening May 16 at the Pescheria Foundation as a contribution to Pesaro Capitale della Cultura 2024.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1091.jpg",
      "link": "https://ordinearchitetti.mi.it/it/formazione/eventi-formativi/festival-cara-casa-workshop-nuovi-paesaggi-domestici",
      "titolo": "CARA CASA.The Travelling Festival on Housing"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The Social Housing Foundation is organizing, with the Foundation of the Architects' Association of Milan, two workshops dedicated to the theme of new domestic landscapes. Paolo Danelli speaks at the workshop “New Domestic Landscapes: rethinking the spaces of the home.”")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1090.jpg",
      "link": "https://www.ilqi.it/stagione/dirette",
      "titolo": "QUOTIDIANO IMMOBILIARE,  LE DIRETTE"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Elena Sacco is the protagonist of QI Le Dirette. The latest work of DAP studio is presented with particular emphasis on the topic of the PNRR. Il Quotidiano Immobiliare, an important online magazine focused on the real estate world in Italy, is a point of reference for professionals in the sector")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1092.jpg",
      "link": "https://www.archilovers.com/projects/287472/UNA-PISCINA-TRA-IL-MAR-IONIO-E-LETNA.html",
      "titolo": "BEST PROJECT 2023"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Our Villa in Sicily is among the Best on Archilovers 2023. Thanks to all the 'lovers' who, once again this year, voted for a DAP studio project!\"")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1089.jpg",
      "link": "https://www.inarch.it/rigenerazione-urbana-viaggio-nel-territorio-lombardo-2/",
      "titolo": "Milano-Varese: the railway as an opportunity for regeneration"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("DAP studio speaks at the conference at the ANCI headquarters in Milan with the presentation of \"ViviBusto 2030\" project  for the regeneration of the historic center of Busto Arsizio.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1080.jpg",
      "link": "https://500x100.com/it/conversation-between-paolo-danelli-e-elena-sacco-alfonso-femia-giorgio-tartaro-500x100-tivu-2021/",
      "titolo": "500x100 SETALK"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("On December 21, 2021, Elena Sacco and Paolo Danelli participate in 500x100 SETALK, in dialogue with Alfonso Femia and Giorgio Tartaro. An opportunity for discussion about the city and architecture.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1081.jpg",
      "link": "https://www.matrix4design.com/it/architettura/ritorno-alla-natura-una-villa-da-sogno-in-sicilia/?rm=1",
      "titolo": "Back to nature: a dream villa in Sicily"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Matrix4Design publishes the Villa in Sicily in Piedimonte Etneo designed by DAP studio ")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1077.jpg",
      "link": "https://ordinearchitetti.ge.it/contemporaneamente-i-vincitori-del-video-contest-sul-tema-dellinclusivita/",
      "titolo": "PIAZZA GIARDINO, AWARDED VIDEO"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("“Piazza Giardino” by Alberto Danelli, is the winner of the video contest “Contemporaneamente” on the theme of inclusiveness."), _c('br'), _vm._v("Screening of works during Genova BeDesign Week 2022, awards ceremony on May 21, 2022")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1078.jpg",
      "link": "https://www.youtube.com/watch?v=Kldw8XEwyas",
      "titolo": "WOW! Webmagazine"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("In this video interview, Elena Sacco e Michele Cortinovis of DAP Studio explains how the new GFT HQ shapes the new values of the post-pandemic workplace. The office becomes a temporary meeting point where to informally discuss and trigger common creative processes.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1074.jpg",
      "link": "/inside/progetto/p133",
      "titolo": "Fitting room n. 16, Arcimboldi Theater"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("DAP studio presents the Dressing Room n. 16 at the Arcimboldi Theater in Milan, designed within the contest \" Vietato l’ingresso\". The new fitting rooms have been opened to the public during the Salone del Mobile 2021")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1073.jpg",
      "link": "/inside/progetto/p128",
      "titolo": "Ferrucci 112 in Turin: a new office landscape"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The magazine Il Sole 24 Ore NT+ publishes the new GFT Headquarter in Turin, inside the former Fiat Engineering completed in the early 1980s by Ludovico Quaroni and Studio Passarelli, now home to offices and innovative realities. ")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1070.jpg",
      "link": "https://www.comunitaresilienti.com/",
      "titolo": "Biennale di Venezia 2021: “Detox” by RebelArchitette at the Padiglione Italia"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Detox will give voice to the work of excellence of Italian architects, including Elena Sacco, DAP studio. The event will be located in the Italian Pavilion Resilient Communities  of the 17th Venice Architecture Biennale with the theme \"How will we live together?\" ")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1065.jpg",
      "link": "/inside/progetto/p128",
      "titolo": "Ex Fiat Engineering and new GFT Headquarter"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("GFT is opening a second Turin headquarter in Corso Ferrucci. A new project by DAP studio, characterized by cylindrical volumes modulating the passage from the public areas to the operating ones.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1066.jpg",
      "link": "#!",
      "titolo": "CULTURAL CENTER IN THE FORMER CASERMA GARIBALDI"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("In the courtyard of the Garibaldi Barracks in Varese, DAP studio is designing a new volume, large, visible and impactful, which will  create a physical connection with the historic building. The extension will contain the core functions of a modern “open library”: spaces for consultation, reading and study. ")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1060.jpg",
      "link": "https://www.artopiagallery.net/i-love-the-gallery-viewing-room",
      "titolo": "I LOVE THE GALLERY"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("\"\"I love the gallery\" is an exhibition about the  20-years history of  Artopia and it is set up in a fascinating abandoned laboratory of the late 19th century. It's a turning point for Rita Urso, who will soon be moving her gallery to this space. DAP studio, which designed the current gallery, is now working on the new project ")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1059.jpg",
      "link": "https://www.internimagazine.it/news/residenza-universitaria-torino/",
      "titolo": "Residence Palestro 3 on Interni, Domusweb, Abitare e many others"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("While the lockdown emptied the university, we came back to Turin to capture  the total transformation and return to its former glory of a mid-nineteenth-century building, located between Piazza Castello and Porta Susa.  In these last months there have been many publications, on Domus, Abitare, Interni, il Sole 24 Ore, Modulo and many others")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1063.jpg",
      "link": "#!",
      "titolo": "A new hub for culture"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("A large Multifunctional Center that will house a library, offices and cultural related services. It is the new project on which DAP studio is working together with 3+Progetti and other partners for the Municipality of Malnate ")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1057.jpg",
      "link": "https://www.abitare.it/it/habitat/urban-design/2020/12/19/nuova-piazza-nuova-vita/",
      "titolo": "PIAZZA-GIARDINO ON ABITARE"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("With vibrancy and precision DAP studio regenerated a square in Garbagnate (Milan), that today serves as a new landmark for the community")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1054.jpg",
      "link": "https://www.archilovers.com/projects/269606/teatro-teca-centro-per-la-musica.html",
      "titolo": "BEST ARCHILOVERS 2020"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Teca Teather has been included by Archilovers in the best projects of 2020")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1049.jpg",
      "link": "https://youtu.be/MI-n7dCQ69k",
      "titolo": "FOODIES CHALLENGE "
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("DAP studio participates in Foodies Challenge, the contest requires to chefs and designers to elaborate new food & design concepts and to express them through visual arts.  The chefs involved in the team are Elisabetta Danelli and Luigi Cattaneo, the video “Foodscape” has been made by Alberto Danelli and Piera Leonetti. "), _c('br'), _vm._v("This edition of the contest proposes the use of cutting boards, coming from the alpine woods of the Val di Fiemme which have been uprootd by bad weather: haute cuisine and creativity are declined to support areas affected by climate change.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1048.jpg",
      "link": "#!",
      "titolo": "SMARTWORKING MODE"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("In this moment of health emergency we are working in smartworking mode, from our homes, connected to each other thanks to a digital platform that allows us to work and carry on our projects!")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1047.jpg",
      "link": "#!",
      "titolo": "VILLA IN SICILY"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("In the fascinating landscape of north-eastern Sicily, between citrus groves and lava ash, the construction of one of our latest projects is now completed, a villa on one floor with large windows that open to the nature, a swimming pool on the roof and sliding  wood panels  that can be used to filter the relationship with the outside.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1043.jpg",
      "link": "/inside/progetto/p107",
      "titolo": "INAUGURATED THE SOCIAL HOUSING BRAGARINA"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The new Social Housing residential complex, on the initiative of the Liguria Social Housing Fund, was inaugurated in La Spezia  The complex, designed by DAP studio and Progetec on behalf of DeA Capital Real Estate SGR, consists of 63 apartments, a ground floor for commercial use, and housing services that can also be used by the surrounding neighbourhood, for a total of 7,000 square meters. This new presence will encourage a strong urban renewal for the nearby areas thanks to its architectural quality, and to the building’s criteria applied in the design: high safety, energy, and environmental sustainability performance. ")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1035.jpg",
      "link": "https://www.archdaily.com/897936/music-center-theater-teca-dapstudio-elena-sacco-nil-paolo-danelli",
      "titolo": "ARCHDAILY PUBLISHES THE TECA CENTER  "
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Archdaily - one of the most visited architecture platform - published the project Centro della Musica. Recently inaugurated in Cassano d’Adda, it is among DAP studio’s best designs.  The Center was built with the aim to spread music culture, especially among young people, and yet  became an attractive site for the whole urban area. It hosts a music school, an auditorium with 300 seats, and a commercial space. ")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1039.jpg",
      "link": "/inside/progetto/p115",
      "titolo": "OPENED THE CAMPUS PALESTRO 3, TORINO "
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The new residence in via Palestro 3 in Turin has been opened to students, promoted by the owner Reale Immobili based on a project by DAP studio and managed by Camplus, a housing provider for students present all over Italy. The structure is the result of the refurbishment of a historic building turned from office to residence, with relational spaces and common areas. The campus can accommodate about 80 students in 19 apartments and provides any sort of services, including gym, laundry and study areas. ")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1032.jpg",
      "link": "#!",
      "titolo": "CONVERSATIONS IN SICILY"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("DAP studio participates in the study day: \"Interno / Esterno - conversazioni in Sicilia\". During the meeting, some projects that explore the topic of indoor/outdoor architecture will be presented. The event, in the Conference Room of the Palazzo di Città di Acireale, is part of the cycle of meetings \"Conversazioni in Sicilia, dibattiti di architettura\", organized by the Order of Architects and the Order of Engineers of the city of Catania. ")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1036.jpg",
      "link": "#!",
      "titolo": "RETHINKING A WAY OF LIVING, TORINO"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Paolo Danelli is one of the lecturer of the international seminar \" Riqualificazione dell’abitare quali sfide per il XXI secolo?\", Organized in Turin at the Lingotto by PUCA - Plan Urbanisme Construction Architecture, in partnership with the Department of Architecture and Design of the Polytechnic of Turin as part of the REHA research and development program. DAP studio shows its work and its design strategies in the dedicated section to Italian historical construction.")])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 357 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "height": "200px",
      "overflow": "hidden"
    }
  }, [_c('img', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "src": _vm.$root.urlsite + 'documenti/backInside.png'
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 358 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('h2', [_vm._v("Essential Links")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Ecosystem")]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://vuejs.org",
      "target": "_blank"
    }
  }, [_vm._v("Core Docs")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://forum.vuejs.org",
      "target": "_blank"
    }
  }, [_vm._v("Forum")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://gitter.im/vuejs/vue",
      "target": "_blank"
    }
  }, [_vm._v("Gitter Chat")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://twitter.com/vuejs",
      "target": "_blank"
    }
  }, [_vm._v("Twitter")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vuejs-templates.github.io/webpack/",
      "target": "_blank"
    }
  }, [_vm._v("Docs for This Template")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "http://router.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vue-router")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vuex.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vuex")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vue-loader.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vue-loader")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/vuejs/awesome-vue",
      "target": "_blank"
    }
  }, [_vm._v("awesome-vue")])])])
}]}

/***/ }),
/* 359 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "savethedate"
  }, [_c('img', {
    attrs: {
      "src": _vm.$root.urlsite + 'documenti/savethedate.png'
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "site-side"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "vmenu"
  }, [_c('div', {
    staticClass: "link first top",
    staticStyle: {
      "margin": "60px 0 4px 0"
    }
  }, [_vm._v("ABOUT US")]), _vm._v(" "), _c('router-link', {
    staticClass: "_page-team",
    attrs: {
      "to": "/inside/profilo/studio"
    }
  }, [_vm._v("profile")]), _vm._v(" "), _c('router-link', {
    staticClass: "_page-team",
    attrs: {
      "to": "/inside/profilo/team"
    }
  }, [_vm._v("team")]), _vm._v(" "), _c('router-link', {
    staticClass: "_page-team",
    attrs: {
      "to": "/inside/profilo/clienti"
    }
  }, [_vm._v("clients")]), _vm._v(" "), _c('router-link', {
    staticClass: "_page-premi",
    attrs: {
      "to": "/inside/profilo/premi"
    }
  }, [_vm._v("awards")]), _vm._v(" "), _c('router-link', {
    staticClass: "_page-mostre",
    attrs: {
      "to": "/inside/profilo/mostre"
    }
  }, [_vm._v("exhibitions")]), _vm._v(" "), _c('router-link', {
    staticClass: "_page-pubblicazioni",
    attrs: {
      "to": "/inside/profilo/pubblicazioni"
    }
  }, [_vm._v("publications")]), _vm._v(" "), _c('router-link', {
    staticClass: "_page-eventi",
    attrs: {
      "to": "/inside/profilo/eventi"
    }
  }, [_vm._v("events")]), _vm._v(" "), _c('div', {
    staticClass: "link first top"
  }, [_vm._v("PROJECTS")]), _vm._v(" "), _c('router-link', {
    staticClass: "_page-selezione",
    attrs: {
      "to": "/progetti"
    }
  }, [_vm._v("selected")]), _vm._v(" "), _c('el-popover', {
    ref: "temiPop",
    attrs: {
      "placement": "left",
      "width": "140",
      "trigger": "hover"
    },
    model: {
      value: (_vm.temiPopV),
      callback: function($$v) {
        _vm.temiPopV = $$v
      },
      expression: "temiPopV"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/tema/1/interiors"
    },
    nativeOn: {
      "click": function($event) {
        _vm.temiPopV = false
      }
    }
  }, [_vm._v("interiors")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tema/2/graftings"
    },
    nativeOn: {
      "click": function($event) {
        _vm.temiPopV = false
      }
    }
  }, [_vm._v("graftings")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tema/3/reuse"
    },
    nativeOn: {
      "click": function($event) {
        _vm.temiPopV = false
      }
    }
  }, [_vm._v("reuse")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tema/4/relational spaces"
    },
    nativeOn: {
      "click": function($event) {
        _vm.temiPopV = false
      }
    }
  }, [_vm._v("relational spaces")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tema/5/texture"
    },
    nativeOn: {
      "click": function($event) {
        _vm.temiPopV = false
      }
    }
  }, [_vm._v("texture")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tema/6/sustainability"
    },
    nativeOn: {
      "click": function($event) {
        _vm.temiPopV = false
      }
    }
  }, [_vm._v("sustainability")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tema/7/transformation"
    },
    nativeOn: {
      "click": function($event) {
        _vm.temiPopV = false
      }
    }
  }, [_vm._v("transformation")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "popover",
      rawName: "v-popover:temiPop",
      arg: "temiPop"
    }],
    staticClass: "vmenupop",
    staticStyle: {
      "width": "90px",
      "margin": "0 auto"
    }
  }, [_vm._v("topics")]), _vm._v(" "), (_vm.$route.params.tipologia != '') ? _c('div', {
    staticStyle: {
      "font-size": "1.3rem",
      "color": "#999999"
    }
  }, [_vm._v(_vm._s(_vm.$route.params.tema))]) : _vm._e(), _vm._v(" "), _c('el-popover', {
    ref: "tipologiePop",
    attrs: {
      "placement": "left",
      "width": "140",
      "trigger": "hover",
      "offset": "0"
    },
    model: {
      value: (_vm.tipologiePopV),
      callback: function($$v) {
        _vm.tipologiePopV = $$v
      },
      expression: "tipologiePopV"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/tipologia/1/urban spaces and landscape"
    },
    nativeOn: {
      "click": function($event) {
        _vm.tipologiePopV = false
      }
    }
  }, [_vm._v("urban spaces and landscape")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tipologia/2/public buildings"
    },
    nativeOn: {
      "click": function($event) {
        _vm.tipologiePopV = false
      }
    }
  }, [_vm._v("public buildings")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tipologia/3/offices and commercial spaces"
    },
    nativeOn: {
      "click": function($event) {
        _vm.tipologiePopV = false
      }
    }
  }, [_vm._v("offices and commercial spaces")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tipologia/4/housing"
    },
    nativeOn: {
      "click": function($event) {
        _vm.tipologiePopV = false
      }
    }
  }, [_vm._v("housing")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tipologia/5/cultural projects"
    },
    nativeOn: {
      "click": function($event) {
        _vm.tipologiePopV = false
      }
    }
  }, [_vm._v("cultural projects")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "popover",
      rawName: "v-popover:tipologiePop",
      arg: "tipologiePop"
    }],
    staticClass: "vmenupop",
    staticStyle: {
      "width": "90px",
      "margin": "0 auto"
    }
  }, [_vm._v("types")]), _vm._v(" "), (_vm.$route.params.tipologia != '') ? _c('div', {
    staticStyle: {
      "font-size": "1.3rem",
      "color": "#999999"
    }
  }, [_vm._v(_vm._s(_vm.$route.params.tipologia))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-bottom yo-align-center"
  }, [_c('div', {
    staticClass: "nav-newsletter"
  }, [_vm._m(1), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
    staticStyle: {
      "color": "#666"
    },
    attrs: {
      "to": "/inside/profilo/newsletter-archivio"
    }
  }, [_vm._v("newsletter archive")])], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-lang"
  }, [_c('a', {
    staticClass: "current",
    attrs: {
      "href": "/site"
    }
  }, [_vm._v("it")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("en")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/site/inside/coming/coming"
    }
  }, [_vm._v("fr")])], 1), _vm._v(" "), _c('router-link', {
    staticClass: "first _page-contatti",
    staticStyle: {
      "margin": "4px 0 8px 0",
      "display": "block"
    },
    attrs: {
      "to": "/inside/contatti/contatti"
    }
  }, [_vm._v("contacts")]), _vm._v(" "), _c('router-link', {
    staticClass: "first _page-contatti",
    staticStyle: {
      "margin": "4px 0 8px 0",
      "display": "block"
    },
    attrs: {
      "to": "/inside/contatti/note_legali"
    }
  }, [_vm._v("legal notes")]), _vm._v(" "), _vm._m(2)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "side-title"
    }
  }, [_c('a', {
    attrs: {
      "href": "/site"
    }
  }, [_c('h1', [_vm._v("DAP"), _c('div', [_vm._v("studio")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://d9x0i.emailsp.com/frontend/forms/Subscription.aspx?idList=4&idForm=65&guid=D741F501-C6A8-4BD4-8FFA-6510561937E7",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/site/images/newsletter-iscrizione.png",
      "alt": "Sign up Newsletter",
      "width": "32"
    }
  }), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "link first top"
  }, [_c('strong', [_vm._v("SIGN UP FOR OUR NEWSLETTER")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-social"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://twitter.com/dap_studio"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(35),
      "alt": "Twitter icon"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.facebook.com/pages/DAPstudio-elena-sacco-paolo-danelli/160426864008613"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(32),
      "alt": "Facebook icon"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.instagram.com/paolo_danelli"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(34),
      "alt": "Instagram icon"
    }
  })])])
}]}

/***/ }),
/* 361 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row progetti"
  }, _vm._l((_vm.filtrati), function(item, index) {
    return _c('div', {
      staticClass: "progetto col col-s12 m6",
      on: {
        "remove": function($event) {
          _vm.onRemove(index)
        }
      }
    }, [(item.link == '1') ? _c('router-link', {
      attrs: {
        "to": '/inside/progetto/p' + item.id
      }
    }, [_c('img', {
      attrs: {
        "src": '/site/images/p/' + item.id + '.jpg'
      }
    })]) : _vm._e(), _vm._v(" "), (item.link != '1') ? _c('img', {
      attrs: {
        "src": '/site/images/p/' + item.id + '.jpg'
      }
    }) : _vm._e(), _vm._v(" "), (item.stato != '') ? _c('el-tooltip', {
      staticStyle: {
        "float": "right"
      },
      attrs: {
        "content": item.stato,
        "placement": "top"
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("menu")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "titolo"
    }, [_vm._v(_vm._s(item.titolo))])], 1)
  }))
},staticRenderFns: []}

/***/ }),
/* 362 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "body": true
      }
    }]
  }, [_c('div', {
    staticClass: "page-header"
  }, [(_vm.$route.params.area == 'invitation') ? _c('el-dropdown', {
    staticClass: "page-menu",
    attrs: {
      "trigger": "click"
    },
    on: {
      "command": _vm.invitationMenu
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("more_vert")])]), _vm._v(" "), _c('el-dropdown-menu', {
    staticStyle: {
      "min-width": "50px",
      "color": "#666666"
    },
    slot: "dropdown"
  }, [(_vm.$route.params.page != 'president-invitation') ? _c('el-dropdown-item', {
    attrs: {
      "command": "president-invitation"
    }
  }, [_vm._v("President's Invitation")]) : _vm._e(), _vm._v(" "), (_vm.$route.params.page != 'society-invitation') ? _c('el-dropdown-item', {
    attrs: {
      "command": "society-invitation"
    }
  }, [_vm._v("IFCC President invitation")]) : _vm._e(), _vm._v(" "), (_vm.$route.params.page != 'auspices') ? _c('el-dropdown-item', {
    attrs: {
      "command": "auspices"
    }
  }, [_vm._v("Auspices")]) : _vm._e(), _vm._v(" "), (_vm.$route.params.page != 'mayor-of-athens') ? _c('el-dropdown-item', {
    attrs: {
      "command": "mayor-of-athens"
    }
  }, [_vm._v("Mayor of Athens")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params.area == 'info') ? _c('el-dropdown', {
    staticClass: "page-menu",
    attrs: {
      "trigger": "click"
    },
    on: {
      "command": _vm.infoMenu
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("more_vert")])]), _vm._v(" "), _c('el-dropdown-menu', {
    staticStyle: {
      "min-width": "50px",
      "color": "#666666"
    },
    slot: "dropdown"
  }, [(_vm.$route.params.page != 'congress-venue') ? _c('el-dropdown-item', {
    attrs: {
      "command": "congress-venue"
    }
  }, [_vm._v("Congress venue")]) : _vm._e(), _vm._v(" "), (_vm.$route.params.page != 'reach-maicc') ? _c('el-dropdown-item', {
    attrs: {
      "command": "reach-maicc"
    }
  }, [_vm._v("How to reach MAICC")]) : _vm._e(), _vm._v(" "), (_vm.$route.params.page != 'get-athens') ? _c('el-dropdown-item', {
    attrs: {
      "command": "get-athens"
    }
  }, [_vm._v("How to get Athens")]) : _vm._e(), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "metromap"
    }
  }, [_vm._v("Metro MAP")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "page-in"
  }, [_c('div', {
    staticClass: "page-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.page)
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 363 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "app",
    class: {
      'mobile': _vm.$teras.device() === 'mobile'
    },
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    ref: "refdue",
    staticClass: "refdue",
    style: ({
      width: _vm.larghezza + 'px',
      display: 'none'
    })
  }), _vm._v(" "), (_vm.$teras.device() != 'mobile') ? _c('div', {
    staticClass: "fixed-side",
    style: ('margin-left:' + (_vm.larghezza - 200) + 'px'),
    attrs: {
      "id": "side"
    }
  }, [_c('site-side')], 1) : _vm._e(), _vm._v(" "), (_vm.$teras.device() == 'mobile') ? _c('header-mobile') : _vm._e(), _vm._v(" "), (_vm.$teras.device() != 'mobile') ? _c('router-view', {
    style: ('padding:0 0 0 20px;width:' + (_vm.larghezza - 200) + 'px'),
    attrs: {
      "name": "main"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$teras.device() == 'mobile') ? _c('router-view', {
    style: ('padding:0 10px 0 10px;'),
    attrs: {
      "name": "main"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 364 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "site-navbar"
  }, [_c('div', {
    staticClass: "row container"
  }, [_c('el-menu', {
    attrs: {
      "default-active": "1",
      "mode": "horizontal",
      "router": true
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-submenu', {
    attrs: {
      "index": "a"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("Informazioni Generali")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "font-color-e",
    attrs: {
      "index": "/inside/info-generali/citta"
    }
  }, [_vm._v("Città di Napoli")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "font-color-e",
    attrs: {
      "index": "/inside/info-generali/sede"
    }
  }, [_vm._v("Sede del congresso")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "font-color-e",
    attrs: {
      "index": "/inside/info-generali/premi"
    }
  }, [_vm._v("Premi")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "font-color-e",
    attrs: {
      "index": "/inside/info-generali/ecm"
    }
  }, [_vm._v("ECM")])], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "b"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("Iscrizioni")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "font-color-e",
    attrs: {
      "index": "inside/info-generali/quote"
    }
  }, [_vm._v("Modalità di iscrizione")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "font-color-e",
    attrs: {
      "index": "iscrizioni"
    }
  }, [_vm._v("Iscrizioni")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "font-color-e",
    attrs: {
      "index": "iscrizioni"
    }
  }, [_vm._v("Iscrizioni Aziendali")])], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/inside/comitati/comitati"
    }
  }, [_vm._v("Comitati")]), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "c"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("Programma")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "font-color-c",
    attrs: {
      "index": "inside/programma/presto-disponibile"
    }
  }, [_vm._v("Presto disponibile")])], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/inside/info-generali/prenotazione-alberghiera"
    }
  }, [_vm._v("Prenotazione Alberghiera")]), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "f"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("Aziende")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "font-color-e",
    attrs: {
      "index": "/inside/aziende/sponsor"
    }
  }, [_vm._v("Sponsor")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "font-color-e",
    attrs: {
      "index": "iscrizioni"
    }
  }, [_vm._v("Iscrizioni")])], 2)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "news"
  }, [(_vm.link.toLowerCase().indexOf('http') > -1) ? _c('a', {
    staticClass: "image-link u-opacity lightbox",
    attrs: {
      "href": _vm.link,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(63)("./" + _vm.image)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.link.toLowerCase().indexOf('http') < 0) ? _c('router-link', {
    staticClass: "image-link u-opacity lightbox",
    attrs: {
      "to": _vm.link
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(63)("./" + _vm.image)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.link.toLowerCase().indexOf('http') > -1) ? _c('a', {
    staticClass: "lightbox",
    attrs: {
      "href": _vm.link,
      "target": "_blank"
    }
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.titolo)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.link.toLowerCase().indexOf('http') < 0) ? _c('router-link', {
    staticClass: "lightbox",
    attrs: {
      "to": _vm.link
    }
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.titolo)
    }
  })]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._t("descrizione")], 2), _vm._v(" "), (_vm.link.toLowerCase().indexOf('http') > -1 && _vm.link != '#!') ? _c('a', {
    staticClass: "share",
    attrs: {
      "href": 'https://www.facebook.com/sharer.php?u=' + _vm.link,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(33),
      "alt": "Facebook icon"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.link.toLowerCase().indexOf('http') < 0 && _vm.link != '#!') ? _c('a', {
    staticClass: "share",
    attrs: {
      "href": 'https://www.facebook.com/sharer.php?u=http://www.dapstudio.com/eng/page/' + _vm.link.split('/')[3] + '.html',
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(33),
      "alt": "Facebook icon"
    }
  })]) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "site-header-mobile"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-s6"
  }, [_c('div', {
    attrs: {
      "id": "side-title"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('h1', [_vm._v("DAP"), _c('div', [_vm._v("studio")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col col-s6 btn-menu yo-align-right"
  }, [_c('a', {
    attrs: {
      "href": "#!"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$teras.mobMmenu = !_vm.$teras.mobMmenu
      }
    }
  }, [(_vm.$teras.mobMmenu) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")]) : _vm._e(), _vm._v(" "), (!_vm.$teras.mobMmenu) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("menu")]) : _vm._e()])])]), _vm._v(" "), (_vm.$teras.mobMmenu) ? _c('div', {
    staticClass: "row menu"
  }, [_c('div', {
    staticClass: "col col-s12"
  }, [_c('el-menu', {
    attrs: {
      "default-active": "1",
      "router": true,
      "unique-opened": true
    }
  }, [_c('el-submenu', {
    attrs: {
      "index": "contributi"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("ABOUT US")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "_page-team",
    attrs: {
      "index": "/inside/profilo/studio"
    }
  }, [_vm._v("profile")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "_page-team",
    attrs: {
      "index": "/inside/profilo/team"
    }
  }, [_vm._v("team")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "_page-team",
    attrs: {
      "index": "/inside/profilo/clienti"
    }
  }, [_vm._v("clients")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "_page-premi",
    attrs: {
      "index": "/inside/profilo/premi"
    }
  }, [_vm._v("awards")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "_page-mostre",
    attrs: {
      "index": "/inside/profilo/mostre"
    }
  }, [_vm._v("exhibitions")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "_page-pubblicazioni",
    attrs: {
      "index": "/inside/profilo/pubblicazioni"
    }
  }, [_vm._v("publications")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "_page-eventi",
    attrs: {
      "index": "/inside/profilo/eventi"
    }
  }, [_vm._v("events")])], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "comitati"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("PROJECTS")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "_page-selezione",
    attrs: {
      "index": "/progetti"
    }
  }, [_vm._v("selected")]), _vm._v(" "), _c('el-popover', {
    ref: "temiPop",
    attrs: {
      "placement": "left",
      "width": "140",
      "trigger": "hover"
    },
    model: {
      value: (_vm.temiPopV),
      callback: function($$v) {
        _vm.temiPopV = $$v
      },
      expression: "temiPopV"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/tema/1/interiors"
    },
    nativeOn: {
      "click": function($event) {
        _vm.temiPopV = false
      }
    }
  }, [_vm._v("interiors")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tema/2/graftings"
    },
    nativeOn: {
      "click": function($event) {
        _vm.temiPopV = false
      }
    }
  }, [_vm._v("graftings")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tema/3/reuse"
    },
    nativeOn: {
      "click": function($event) {
        _vm.temiPopV = false
      }
    }
  }, [_vm._v("reuse")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tema/4/relational spaces"
    },
    nativeOn: {
      "click": function($event) {
        _vm.temiPopV = false
      }
    }
  }, [_vm._v("relational spaces")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tema/5/texture"
    },
    nativeOn: {
      "click": function($event) {
        _vm.temiPopV = false
      }
    }
  }, [_vm._v("texture")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tema/6/sustainability"
    },
    nativeOn: {
      "click": function($event) {
        _vm.temiPopV = false
      }
    }
  }, [_vm._v("sustainability")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tema/7/transformation"
    },
    nativeOn: {
      "click": function($event) {
        _vm.temiPopV = false
      }
    }
  }, [_vm._v("transformation")])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "popover",
      rawName: "v-popover:temiPop",
      arg: "temiPop"
    }],
    staticClass: "el-menu-item vmenupop"
  }, [_vm._v("topics")]), _vm._v(" "), _c('el-popover', {
    ref: "tipologiePop",
    attrs: {
      "placement": "left",
      "width": "140",
      "trigger": "hover",
      "offset": "0"
    },
    model: {
      value: (_vm.tipologiePopV),
      callback: function($$v) {
        _vm.tipologiePopV = $$v
      },
      expression: "tipologiePopV"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/tipologia/1/urban spaces and landscape"
    },
    nativeOn: {
      "click": function($event) {
        _vm.tipologiePopV = false
      }
    }
  }, [_vm._v("urban spaces and landscape")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tipologia/2/public buildings"
    },
    nativeOn: {
      "click": function($event) {
        _vm.tipologiePopV = false
      }
    }
  }, [_vm._v("public buildings")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tipologia/3/offices and commercial spaces"
    },
    nativeOn: {
      "click": function($event) {
        _vm.tipologiePopV = false
      }
    }
  }, [_vm._v("offices and commercial spaces")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tipologia/4/housing"
    },
    nativeOn: {
      "click": function($event) {
        _vm.tipologiePopV = false
      }
    }
  }, [_vm._v("housing")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tipologia/5/cultural projects"
    },
    nativeOn: {
      "click": function($event) {
        _vm.tipologiePopV = false
      }
    }
  }, [_vm._v("cultural projects")])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "popover",
      rawName: "v-popover:tipologiePop",
      arg: "tipologiePop"
    }],
    staticClass: "el-menu-item vmenupop"
  }, [_vm._v("types")])], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/inside/contatti/contatti"
    }
  }, [_vm._v("CONTACTS")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-bottom yo-align-center"
  }, [_c('div', {
    staticClass: "nav-lang"
  }, [_c('a', {
    attrs: {
      "href": "/site"
    }
  }, [_vm._v("it")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("en")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/inside/coming/coming"
    }
  }, [_vm._v("fr")])], 1), _vm._v(" "), _c('router-link', {
    staticClass: "first _page-contatti",
    staticStyle: {
      "margin": "4px 0 8px 0",
      "display": "block"
    },
    attrs: {
      "to": "/inside/contatti/note_legali"
    }
  }, [_vm._v("legal notes")]), _vm._v(" "), _vm._m(0)], 1)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-social"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://twitter.com/dap_studio"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(35),
      "alt": "Twitter icon"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.facebook.com/pages/DAPstudio-elena-sacco-paolo-danelli/160426864008613"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(32),
      "alt": "Facebook icon"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.instagram.com/dapstudio"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(34),
      "alt": "Instagram icon"
    }
  })])])
}]}

/***/ }),
/* 367 */,
/* 368 */,
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Header-mobile.vue": 60,
	"./Hello.vue": 337,
	"./Home.vue": 338,
	"./Image-home.vue": 339,
	"./Image-inside.vue": 340,
	"./Inside.vue": 341,
	"./News.vue": 61,
	"./Page.vue": 342,
	"./Progetti.vue": 343,
	"./Savethedate.vue": 344,
	"./Site-footer.vue": 345,
	"./Site-header.vue": 346,
	"./Site-navbar.vue": 347,
	"./Site-side.vue": 62,
	"./Tema.vue": 348,
	"./Tipologia.vue": 349
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 369;

/***/ })
]),[133]);


// WEBPACK FOOTER //
// static/js/app.1a7da19782bea73a421a.js